
window.__TOOT_TIPS=[
 "🐦 Hey, I'm Toot! I'm a bulbul, so singing is kind of my thing.",
 "🎶 Bayati often sounds warm and gentle. Start by humming its home note.",
 "🌧️ Saba can sound sad and thoughtful. Keep your jaw loose and let the melody do the work.",
 "🌙 Hijaz has a big, dramatic sound. Listen to the shape, then copy it back.",
 "📚 One is a maqam. More than one are called maqamat. Easy!",
 "🗝️ A maqam is more than a scale. Its phrases and resting notes give it personality.",
 "🪶 Why do birds practice scales? To hit the high tweets!",
 "🔁 Tough run? Slow it to 0.75×, learn the notes, then speed it back up.",
 "🪽 Don't push out extra air. A smooth, steady breath will carry the phrase.",
 "🪺 Can't find the note? Hum it first. That's your easy landing spot.",
 "🎙️ Your pitch line is here to help, not judge. Wobbles just show you what to practice next.",
 "🐤 Nice held note! That was egg-cellent.",
 "🌤️ I skipped my warm-up once. It was a big mis-tweet.",
 "🎯 First copy where the melody goes up and down. Then clean up each note.",
 "🎼 Pick a key that feels comfortable. Changing the key is not cheating!",
 "✨ Short practice rounds work best. Even birds learn one tweet at a time.",
 "🤫 When the red light comes on, I zip my beak. Your recording comes first.",
 "🌬️ Good singing starts with simple things: tall posture, easy breath, relaxed sound.",
 "💛 Beautiful recitation isn't only about hitting notes. Breath, phrasing, and meaning matter too.",
 "🐣 Why did the bulbul join voice class? He wanted better tweet-nique!",
 "📈 Need another take? That's okay — practice makes peck-fect."
];
// ===== Toot flight engine (ported from the original toot-mascot-design.html) =====
const wrap=document.querySelector('.toot-wrap'), toot=document.querySelector('.toot'), shadow=document.querySelector('.tshadow');
const rigLayer=document.getElementById('toot-layer');
let BW=100, pos={x:innerWidth*0.5,y:innerHeight*0.4}, FR=0, FSX=1, FSY=1;
let rigPageSpace=false;
let micLive=false, perchedOn=null, state='perch', busy=false, whooshFlag=false;
const FLAP_RISE=500, TUCK_FALL=450, BOUND_PERIOD=950, BEAT_MS=340;
// ---- global gates: ONE performance and ONE voice at a time ----
let actUntil=0, sndUntil=0, eyeT=null, beakT=null, lastLandT=0;
const tryAct=ms=>{ const n=performance.now(); if(n<actUntil) return false; actUntil=n+ms; return true; };
const reduceMotion=!!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);
let branchTapTimes=[], pendingBranchClick=0, angryUntil=0, angryTimer=0, navMouthTimers=[], branchIdleTimer=0;

function isBranchSeat(){
  return !!(perchedOn&&perchedOn.classList&&perchedOn.classList.contains('saif-practice__toot-seat'));
}
function isAngry(){ return performance.now()<angryUntil; }
function clearPendingBranchSong(){ clearTimeout(pendingBranchClick); pendingBranchClick=0; }
function clearNavMouth(){
  navMouthTimers.forEach(function(id){ clearTimeout(id); });
  navMouthTimers=[];
}
function clearAnger(restoreFace){
  angryUntil=0;
  clearTimeout(angryTimer); angryTimer=0;
  toot.classList.remove('is-angry');
  if(restoreFace&&!micLive){ setEyes('open'); setBeak('closed'); }
}
function armAngryEnd(){
  clearTimeout(angryTimer);
  var left=angryUntil-performance.now();
  angryTimer=setTimeout(function(){
    var remaining=angryUntil-performance.now();
    if(remaining>0){ armAngryEnd(); return; }
    clearAnger(!micLive);
  },Math.max(30,left+20));
}
function enterAngry(){
  var n=performance.now();
  angryUntil=n+2000;
  actUntil=angryUntil;
  clearPendingBranchSong();
  clearNavMouth();
  clearInterval(singT);
  clearTimeout(eyeT); clearTimeout(beakT);
  toot.classList.remove('sing','wave','blink','rx-bounce','rx-hop');
  try{ tnClearNotes(); }catch(e){}
  try{ rxClear(); }catch(e){}
  try{ if(window.SaifToot&&window.SaifToot.cancelReactions) window.SaifToot.cancelReactions(false); }catch(e){}
  setBeak('closed');
  setEyes('angry');
  toot.classList.add('is-angry');
  armAngryEnd();
}

function setSize(v){ BW=v; wrap.style.width=BW+'px'; wrap.style.height=BW+'px'; document.getElementById('sizeval').textContent=BW+'px'; }
setSize(100);
/* The wrapper and its shadow are one moving rig. Transition ownership is
   explicit because browsers normalise inline transition strings; comparing the
   serialised CSS text left tutorial easing attached after teardown. */
let rigTransitionOwner=null;
function setRigTransition(value,owner){
  rigTransitionOwner=owner||null;
  wrap.style.transition=value||'none';
  if(shadow) shadow.style.transition=value||'none';
}
function clearRigTransition(owner){
  if(owner&&rigTransitionOwner&&rigTransitionOwner!==owner) return false;
  rigTransitionOwner=null;
  wrap.style.transition='none';
  if(shadow) shadow.style.transition='none';
  return true;
}
function resetRigPose(){
  FR=0; FSX=1; FSY=1;
  toot.classList.remove('flying','flaring');
}
function rigScreenPos(){
  return {x:pos.x-(rigPageSpace?scrollX:0),y:pos.y-(rigPageSpace?scrollY:0)};
}
function rigPageAnchor(){
  var p=rigScreenPos();
  return {px:p.x+scrollX,py:p.y+scrollY};
}
function nativeMobilePerch(el){
  return !!(innerWidth<=699&&el&&el.isConnected&&el.closest&&el.closest('.saif-practice')&&!window.__tootTeaching&&!hasFixedAncestor(el));
}
function setRigPageSpace(on){
  on=!!on;
  if(on===rigPageSpace) return;
  if(on){ pos.x+=scrollX; pos.y+=scrollY; }
  else { pos.x-=scrollX; pos.y-=scrollY; }
  rigPageSpace=on;
  var mode=on?'absolute':'fixed';
  if(rigLayer) rigLayer.style.position=mode;
  wrap.style.position=mode;
  if(shadow) shadow.style.position=mode;
}
function apply(){ wrap.style.transform='translate('+pos.x+'px,'+pos.y+'px) rotate('+FR.toFixed(2)+'deg) scale('+FSX.toFixed(3)+','+FSY.toFixed(3)+')';
  const sw=BW*0.52, air=(state!=='perch'); shadow.style.width=sw+'px'; shadow.style.height=(sw*0.26)+'px';
  shadow.style.transform='translate('+(pos.x+BW/2-sw/2)+'px,'+(pos.y+BW*0.9)+'px)'; shadow.style.opacity=air?0:0.9;
  if(tipVisible) placeTip(); }

// ---- targets: element+anchor OR a free viewport point -> wrap top-left (feet on the anchor) ----
function clampTL(fx,fy){ return { x:Math.max(4,Math.min(innerWidth-BW-4,fx-BW/2)), y:Math.max(4,Math.min(innerHeight-BW*0.5,fy-BW*0.94)) }; }
function anchorRx(el){ return (el&&el.dataset&&el.dataset.perchRx)?+el.dataset.perchRx:0.5; } // per-perch anchor: sit over padding, never over text
function anchorRy(el){ return (el&&el.dataset&&el.dataset.perchRy)?+el.dataset.perchRy:0; }   // vertical anchor: feet can sit a fraction DOWN the element's face
function resolveTarget(t){ if(t.x!=null) return clampTL(t.x,t.y);
  const r=t.el.getBoundingClientRect(); return clampTL(r.left+r.width*(t.rx??anchorRx(t.el)), r.top+r.height*(t.ry??anchorRy(t.el))); }
/* Ordinary seats live in the document, so their flights must live in document
   coordinates too. Only a genuinely fixed overlay (the tutorial card) owns a
   viewport-space flight. This distinction also lets emitted FX choose the same
   coordinate system as the surface Toot is standing on. */
function hasFixedAncestor(el){
  for(let n=el;n&&n.nodeType===1;n=n.parentElement){
    try{ if(getComputedStyle(n).position==='fixed') return true; }catch(e){}
  }
  return false;
}
function flightUsesPageSpace(t){ return !!(t&&t.el&&!hasFixedAncestor(t.el)); }
function resolveFlightTarget(t,pageSpace){
  if(!pageSpace) return resolveTarget(t);
  const r=t.el.getBoundingClientRect();
  return {
    x:r.left+r.width*(t.rx??anchorRx(t.el))-BW/2+scrollX,
    y:r.top+r.height*(t.ry??anchorRy(t.el))-BW*0.94+scrollY
  };
}
function effectsUseViewportSpace(){
  return !!window.__tootTeaching||hasFixedAncestor(perchedOn);
}
function perches(){ const all=[...document.querySelectorAll('[data-perch]')]; return innerWidth<=820?all.filter(el=>!el.classList.contains('card')):all; }
function visible(el){ const r=el.getBoundingClientRect(); return r.top>96+BW*0.94+4 && r.bottom<innerHeight-8 && r.width>0; } // headroom: his body must clear the sticky nav

// ---- cubic path with arc-length table + tangent sampling ----
function cubic(a,b,c,d,t){ const m=1-t; return { x:m*m*m*a.x+3*m*m*t*b.x+3*m*t*t*c.x+t*t*t*d.x, y:m*m*m*a.y+3*m*m*t*b.y+3*m*t*t*c.y+t*t*t*d.y }; }
let _hop=0; // flight parity: alternating lateral arcs so no two hops carve the same line
function buildPath(from,to,style){ const dx=to.x-from.x, dy=to.y-from.y, dist=Math.hypot(dx,dy); let p1,p2;
  if(style==='dive'){ p1={x:from.x+dx*.18,y:from.y-Math.min(90,dist*.15)}; p2={x:to.x-dx*.06,y:to.y-Math.min(230,dist*.5)}; }
  else if(style==='sweep'){ p1={x:from.x+dx*.4,y:from.y+dy*.1-40}; p2={x:to.x-dx*.4,y:to.y-dy*.1+40}; }
  else { const lift=Math.max(90,Math.min(240,dist*.35)); p1={x:from.x+dx*.28,y:from.y-lift*.7}; p2={x:to.x-dx*.28,y:to.y-lift}; }
  if(Math.abs(dx)<0.35*dist){ // near-vertical chord = "paratrooper drop": bow the path sideways, alternating by hop
    let sx=((_hop%2)?1:-1)*Math.min(170,dist*0.30);
    const midX=(from.x+to.x)/2;
    if(midX+sx>innerWidth-220) sx=-Math.abs(sx); else if(midX+sx<220) sx=Math.abs(sx);
    p1.x+=sx; p2.x+=sx*0.6; }
  const N=90,pts=[],len=[0]; for(let i=0;i<=N;i++)pts.push(cubic(from,p1,p2,to,i/N));
  for(let i=1;i<=N;i++)len.push(len[i-1]+Math.hypot(pts[i].x-pts[i-1].x,pts[i].y-pts[i-1].y)); return {pts,len,total:len[N],N}; }
function sampleAt(path,s){ s=Math.max(0,Math.min(path.total,s)); let lo=0,hi=path.N;
  while(lo<hi){const mid=(lo+hi)>>1; if(path.len[mid]<s)lo=mid+1; else hi=mid;} const i=Math.max(1,lo);
  const seg=path.len[i]-path.len[i-1]||1, f=(s-path.len[i-1])/seg, a=path.pts[i-1], b=path.pts[i];
  return {x:a.x+(b.x-a.x)*f, y:a.y+(b.y-a.y)*f, vx:(b.x-a.x)/seg, vy:(b.y-a.y)/seg}; }

// ---- the flight leg ----
let anim=null, animFinish=null;
function cancelActiveFlight(){
  if(animFinish){ const cancel=animFinish; animFinish=null; cancel(true); }
  if(anim){ cancelAnimationFrame(anim); anim=null; }
}
function flyLeg(target, opts={}){
  /* A newer destination supersedes the old leg. Resolve the old promise as
     cancelled before starting the new rAF; otherwise its owning script keeps
     busy=true forever even though the replacement flight visibly lands. */
  cancelActiveFlight();
  return new Promise(resolve=>{
  let finished=false;
  const finish=cancelled=>{
    if(finished)return;
    finished=true;
    if(animFinish===finish){ animFinish=null; anim=null; }
    resolve({cancelled:!!cancelled});
  };
  animFinish=finish;
  if(micLive){finish(true);return;}
  _hop++;
  const pageSpace=flightUsesPageSpace(target);
  const nativeRig=pageSpace&&nativeMobilePerch(target.el);
  let to=resolveFlightTarget(target,pageSpace);
  let screenFrom=rigScreenPos();
  let from=pageSpace?{x:screenFrom.x+scrollX,y:screenFrom.y+scrollY}:screenFrom;
  let style=opts.style||'swoop', path=buildPath(from,to,style);
  const vBase= opts.v || (style==='dive'?560:600); let s=0,last=null,cycT=Math.random()*BOUND_PERIOD,beatT=0,off=0; whooshFlag=false;
  state='fly'; perchedOn=null; clearInterval(singT); setBeak('closed');
  setRigPageSpace(nativeRig);
  clearPendingBranchSong(); branchTapTimes=[]; clearNavMouth();
  toot.classList.remove('idle','sing','wave','flaring','land','tn-singing','em-headtilt','em-lookaround','em-crestflick','em-tailflick','em-preen','em-fluff','em-hop','em-stretch','rx-bounce','rx-hop','fx-hop','fx-landjoy');
  if(typeof tnClearNotes==='function')tnClearNotes(); // stop the note stream so it can't follow him into flight
  actUntil=0; clearTimeout(eyeT); clearTimeout(beakT); setEyes('open'); hideTip(); // flight resets any pending face/act/tip
  toot.classList.add('flying'); setRigTransition('none');   /* silent, precise takeoff */
  cancelAnimationFrame(anim);
  anim=requestAnimationFrame(function step(now){ if(micLive){finish(true);return;}
    if(last==null)last=now; const dt=Math.min(48,now-last); last=now;
    if(target.el){ const nt=resolveFlightTarget(target,pageSpace); // page flights ignore viewport scroll but still track real layout movement
      const tdx=nt.x-to.x, tdy=nt.y-to.y;
      if(Math.abs(tdx)+Math.abs(tdy)>3){ to=nt; // slide the path (pure translation: len table stays valid) so s/remain survive — landing decel + flare never reset, and the bob offset is never re-baked
        for(const q of path.pts){ q.x+=tdx; q.y+=tdy; } } }
    const remain=path.total-s;
    let v=vBase; if(style==='dive')v=520+640*Math.min(1,s/(path.total*.6)); if(opts.land)v=Math.min(v,170+remain*2.6);
    s+=v*dt/1000; const p=sampleAt(path,s); const vy=p.vy*v, climbing=vy<-60, plunging=vy>300, flaring=opts.land&&remain<150;
    const fadeIn=Math.min(1,s/Math.min(170,path.total*0.28)), fadeOut=Math.min(1,remain/Math.max(190,path.total*0.28));
    const env=Math.max(0,Math.min(fadeIn,fadeOut)), amp=Math.max(10,Math.min(22,v*0.031));
    let boundLift=0, flapping=false;
    if(flaring){ toot.classList.add('flaring'); }
    else { toot.classList.remove('flaring');
      if(style==='dive'&&s>path.total*.17&&remain>230){ if(!whooshFlag){whooshFlag=true;whoosh();} flapping=true; }
      else if(climbing||v<430){ flapping=true; }
      else { cycT+=dt; if(cycT>=BOUND_PERIOD)cycT-=BOUND_PERIOD;
        if(plunging){} else if(cycT<FLAP_RISE){ const u=cycT/FLAP_RISE,sm=u*u*(3-2*u); boundLift=amp*(2*sm-1); flapping=true; }
        else { const w=(cycT-FLAP_RISE)/TUCK_FALL; boundLift=amp*(1-2*w*w); } } }
    let beatBob=0; if(flapping){ beatT+=dt; if(beatT>=BEAT_MS)beatT-=BEAT_MS; beatBob=1.5*(1-Math.cos(2*Math.PI*beatT/BEAT_MS)); }
    off+=(env*(boundLift+beatBob)-off)*(1-Math.exp(-dt/60));
    pos.x=p.x-(pageSpace&&!nativeRig?scrollX:0); pos.y=p.y-off-(pageSpace&&!nativeRig?scrollY:0);
    const bankT=flaring?0:Math.max(-24,Math.min(24,p.vx*v*0.05)); FR+=(bankT-FR)*(1-Math.exp(-dt/(flaring?55:85)));
    const pitch=Math.max(-1,Math.min(1,vy/620)), depth=flaring?1:1+0.13*env+Math.max(0,pitch)*0.09;
    FSX+=(depth-FSX)*(1-Math.exp(-dt/120)); FSY+=(depth*(1-0.05*pitch)-FSY)*(1-Math.exp(-dt/120));
    apply();
    if(s<path.total) anim=requestAnimationFrame(step);
    else { FR=0;FSX=1;FSY=1; const e=sampleAt(path,path.total);
      pos.x=e.x-(pageSpace&&!nativeRig?scrollX:0); pos.y=e.y-(pageSpace&&!nativeRig?scrollY:0);
      if(opts.land){ toot.classList.remove('flying','flaring'); state='perch'; perchedOn=target.el||null;
        freeAnchor=perchedOn?null:rigPageAnchor(); apply();
        if(perchedOn) rideNow(); // snap to the exact dataset anchor (clamped landings self-correct instantly)
        toot.classList.add('idle','land'); setTimeout(()=>toot.classList.remove('land'),560); lastLandT=performance.now();
        if(opts.quiet){ if(_hop%3===0) emCrestFlick(); } // ambient hops settle modestly — the show is for invited flights
        else { fxLandFlourish(); emCrestFlick();   /* the flourish stays, the peep does not */
          flashEyes('joy',800); setBeak('smile'); clearTimeout(beakT); beakT=setTimeout(()=>setBeak('closed'),700); } // stuck the landing!
        setTimeout(()=>finish(false),540); }
      else if(opts.endPose==='hover'){ toot.classList.remove('flaring'); state='hover'; apply(); finish(false); }
      else { toot.classList.remove('flying','flaring'); state='perch';
        if(!perchedOn) freeAnchor=rigPageAnchor(); apply(); finish(false); } }
  });
}); }

function hoverBob(ms){ return new Promise(resolve=>{ if(micLive){resolve();return;} state='hover'; toot.classList.add('flying');
  const y0=pos.y,x0=pos.x; let t0=null;
  requestAnimationFrame(function bob(now){ if(micLive){resolve();return;} if(t0==null)t0=now; const t=now-t0;
    pos.y=y0+Math.sin(t/1000*Math.PI*2*2.6)*3.5; pos.x=x0+Math.sin(t/1000*Math.PI*2*0.55+0.7)*4.5; apply();
    if(t<ms)requestAnimationFrame(bob); else { pos.y=y0;pos.x=x0;apply(); resolve(); } }); }); }

const wait=ms=>new Promise(r=>setTimeout(r,ms));
async function runScript(steps){ if(busy||micLive)return; busy=true; setBtns(true);
  try{ for(const st of steps){
    if(micLive) break; // mic went live: abandon the rest of the choreography so busy clears immediately
    if(st.place){ setRigPageSpace(false); const p=resolveTarget(st.place); pos.x=p.x;pos.y=p.y;FR=0;FSX=FSY=1; state='perch'; perchedOn=st.place.el||null;
      freeAnchor=perchedOn?null:rigPageAnchor(); if(perchedOn) rideNow(); else apply(); }
    else if(st.fly){ const leg=await flyLeg(st.fly, st); if(leg&&leg.cancelled) break; }
    else if(st.hover!=null) await hoverBob(st.hover);
    else if(st.sing){ doSing(true); await wait(st.ms||2000); }
    else if(st.wave){ doWave(true); await wait(st.ms||1600); }
    else if(st.scrollTo){ st.scrollTo.scrollIntoView({behavior:'smooth',block:'center'}); await wait(560); }
    else if(st.wait) await wait(st.wait);
  } } finally { busy=false; setBtns(false); }
}
function setBtns(d){ var b=document.getElementById('callbtn'); if(b) b.disabled=d; } // the Call button no longer ships
window.__dbg=()=>{const p=rigScreenPos();return {state,busy,perched:!!perchedOn,free:!!freeAnchor,x:Math.round(p.x),y:Math.round(p.y),pageRig:rigPageSpace};}; // preprod diagnostics

// ---- perched behaviour: stay glued to his spot ON THE PAGE while scrolling ----
// (raw element position, NO clamp — so scrolling down carries him up & out of view,
//  leaving him in his old place until you Call him back down.)
let _rideRAF=0, freeAnchor=null; // page-coords anchor for element-less perches (free-spot landings, mid-flight hush)
function rideNow(){ _rideRAF=0; if(state!=='perch') return; // ride whenever perched — even mid-choreography (busy); only flight owns pos
  if(!window.__tootTeaching&&rigTransitionOwner==='tutorial') clearRigTransition('tutorial');
  if(perchedOn){ const nativePage=nativeMobilePerch(perchedOn); setRigPageSpace(nativePage); const r=perchedOn.getBoundingClientRect();
    pos.x=r.left+r.width*anchorRx(perchedOn)-BW/2+(nativePage?scrollX:0);
    pos.y=r.top+r.height*anchorRy(perchedOn)-BW*0.94+(nativePage?scrollY:0); apply(); }
  else if(freeAnchor){ setRigPageSpace(false); pos.x=freeAnchor.px-scrollX; pos.y=freeAnchor.py-scrollY; apply(); } } // glued to the PAGE, never the screen
function ride(force){
  /* On phones a perched bird now uses page coordinates and scrolls with the
     branch in the browser's own compositor. Mobile scroll events are throttled
     and cannot produce a perfectly glued fixed-position follower. Resize still
     remeasures the real anchor; flight and fixed tutorial cards stay viewport-led. */
  force=force===true;
  if(state==='perch'){
    if(rigPageSpace&&!force) return;
    if(_rideRAF){ cancelAnimationFrame(_rideRAF); _rideRAF=0; } rideNow(); return; }
  if(!_rideRAF) _rideRAF=requestAnimationFrame(rideNow);
}
addEventListener('scroll',function(){ride(false);},{passive:true});
addEventListener('resize',function(){ride(true);},{passive:true});
if(window.visualViewport){ visualViewport.addEventListener('resize',function(){ride(true);},{passive:true}); visualViewport.addEventListener('scroll',function(){ride(false);},{passive:true}); } // iOS URL-bar collapse re-glue
ride(true);

function setBeak(k){ for(const b of ['closed','med','open','smile','half','big','broad']){ const el=document.querySelector('.beak-'+b); if(el) el.style.display=(b===k)?'block':'none'; } }
const EYES=['open','happy','glance','joy','angry','wide'];
function setEyes(k){ for(const e of EYES){ const el=document.querySelector('.eyes-'+e); if(el) el.style.display=(e===k)?'block':'none'; } }
function flashEyes(k,ms){ if(micLive)return; setEyes(k); clearTimeout(eyeT); eyeT=setTimeout(()=>setEyes('open'),ms||800); }
let singT=null;
function doSing(force){ if(micLive)return; if(!force&&(state!=='perch'||!tryAct(1900)))return;
  const durMs=chirpMelody(); if(!durMs){ if(!force)actUntil=0; return; } // no free voice = no silent mouthing
  actUntil=Math.max(actUntil,performance.now()+durMs+350);
  toot.classList.add('sing'); tnSingFX(Math.min(1500,durMs)); emTailFlick();
  const seq=['big','med','broad','half','big','open','broad','closed','half','big','med'];
  const steps=Math.max(6,Math.round(durMs/150)); let i=0; clearInterval(singT); // mouth for exactly the song's length
  singT=setInterval(()=>{ setBeak(seq[i%seq.length]); if(++i>steps){clearInterval(singT); toot.classList.remove('sing');
    setBeak('smile'); clearTimeout(beakT); beakT=setTimeout(()=>setBeak('closed'),700); } },150); } // proud little smile after the song
function doWave(force){ if(micLive)return; if(!force&&(state!=='perch'||!tryAct(1700)))return; if(force)actUntil=performance.now()+1700;
  toot.classList.remove('wave'); void toot.offsetWidth; toot.classList.add('wave'); setTimeout(()=>toot.classList.remove('wave'),1600); }
function scheduleBranchWave(){
  clearTimeout(branchIdleTimer);
  branchIdleTimer=setTimeout(function(){
    if(!reduceMotion&&!micLive&&!busy&&!window.__tootTeaching&&!document.hidden&&state==='perch'&&
       isBranchSeat()&&!isAngry()&&visible(perchedOn)&&performance.now()>=actUntil){
      /* Keep both pieces of his branch personality: a greeting wave OR a
         two-wing flutter. The flutter changes only the SVG pose; perchedOn,
         pos and the approved branch seat never change. */
      if(Math.random()<0.58) doWave(true); else fxFlutterHop(true);
    }
    scheduleBranchWave();
  },22000+Math.random()*16000);
}
scheduleBranchWave();
function singFromBranch(){
  pendingBranchClick=0;
  if(micLive||busy||state!=='perch'||!isBranchSeat()||isAngry()) return;
  var audioWait=sndUntil-performance.now();
  if(audioWait>0){
    pendingBranchClick=setTimeout(singFromBranch,audioWait+20);
    return;
  }
  actUntil=0;
  toot.classList.remove('wave');
  /* A branch click should sound AND look like a songbird answering. This is the
     stationary spread-wing flutter, not a flyTo/flyLeg relocation. */
  try{ fxFlutterHop(true); }catch(e){}
  doSing(true);
}
window.callSing=()=>doSing();

// blink (2.4-6.2s, ~18% double)
/* Toot's tip bubbles are paused while they are reworked (owner, 2026-07-29).
   Flip to true to bring them back — nothing else needs changing. The guided
   tour is separate (it speaks through its own card) and still runs. */
const TOOT_TIPS_ENABLED = false;

// ---- Toot's tip bubble: occasional helpful notes from his beak, usually with a short song ----
const tipEl=document.getElementById('tipbubble');
let tipVisible=false, tipHideT=null, tipsShown=0, tipQueue=[];
const TIPS=window.__TOOT_TIPS||[];
function placeTip(){ if(!tipVisible)return;
  const screen=rigScreenPos(), px=screen.x, py=screen.y;
  if(py<-BW*0.4||py>innerHeight-BW*0.3||px<-BW*0.4||px>innerWidth-BW*0.3){ hideTip(); return; } // no birdless bubbles: hide when he leaves view
  const bw=tipEl.offsetWidth, bh=tipEl.offsetHeight;
  const bx=px+BW*0.55, by=py+BW*0.42; let flip=false, below=false;
  let x=bx+BW*0.14, y=by-bh-BW*0.34;
  if(x+bw>innerWidth-8){ x=bx-bw-BW*0.14; flip=true; }
  if(y<72){ y=py+BW*0.98+10; below=true; }
  // never cover the content he's perched on: if the bubble overlaps the perch element, go below; still overlapping → move beside it
  if(perchedOn&&perchedOn.isConnected){ const pr=perchedOn.getBoundingClientRect();
    const hits=(bx2,by2)=>bx2<pr.right&&bx2+bw>pr.left&&by2<pr.bottom&&by2+bh>pr.top;
    if(!below&&hits(x,y)){ y=py+BW*0.98+10; below=true; }
    if(hits(x,y)){ x=pr.left-bw-12; if(x<8){ x=Math.min(innerWidth-bw-8,pr.right+12); } } }
  /* On phones the tree branch has a deliberately reserved perch pocket above
     the pitch stage. Keep branch chatter inside that pocket: the generic
     above-the-beak placement otherwise lands directly on the review pills and
     reference controls, even though there is clear room beside Toot. */
  if(innerWidth<=699&&perchedOn&&perchedOn.classList&&perchedOn.classList.contains('saif-practice__toot-seat')){
    const studio=perchedOn.closest('.saif-practice');
    const header=studio&&studio.querySelector('.saif-practice__header--bar');
    const live=studio&&studio.querySelector('.saif-practice__live');
    if(header&&live){
      const hr=header.getBoundingClientRect(), lr=live.getBoundingClientRect();
      x=Math.max(8,Math.min(innerWidth-bw-8,px-bw-10));
      y=Math.max(hr.bottom+8,Math.min(py-BW*0.02,lr.top-bh-8));
      flip=true; below=false;
    }
  }
  tipEl.classList.toggle('flip',flip); tipEl.classList.toggle('below',below);
  tipEl.style.left=Math.max(8,x).toFixed(1)+'px'; tipEl.style.top=Math.max(8,y).toFixed(1)+'px'; }
function showTip(text){ if(!TOOT_TIPS_ENABLED)return false;   /* paused — see TOOT_TIPS_ENABLED */
  if(micLive||busy||tipVisible||state!=='perch'||(!TIPS.length&&!text))return false;
  if(window.__tootTeaching)return false;   /* the lesson is the message right now */
  if(!text){ if(!tipQueue.length) tipQueue=TIPS.slice().sort(()=>Math.random()-0.5); text=tipQueue.pop(); }
  tipEl.querySelector('.txt').textContent=text; tipVisible=true; tipEl.classList.add('show'); placeTip();
  if(Math.random()<0.75) tipSong(); // usually a little song announces it
  clearTimeout(tipHideT); tipHideT=setTimeout(hideTip, 7200+Math.random()*1600);
  return true; }
function hideTip(){ clearTimeout(tipHideT); tipVisible=false; tipEl.classList.remove('show'); }
tipEl.addEventListener('click',hideTip); // (top-level function showTip is already the window.showTip preprod hook)
function tipTick(){ if(!TOOT_TIPS_ENABLED) return;   /* paused — no idle retries */
  if(tipsShown>=8) return;
  const screen=rigScreenPos();
  const onScreen = screen.y>-BW*0.5 && screen.y<innerHeight-BW*0.4;
  const ok = !micLive&&!busy&&state==='perch'&&!document.hidden&&!tipVisible&&onScreen&&performance.now()>=actUntil
    &&performance.now()-lastLandT>2500&&showTip(); // let him settle before he speaks
  if(ok){ tipsShown++; setTimeout(tipTick, 34000+Math.random()*26000); } // next tip in ~34-60s
  else setTimeout(tipTick, 11000+Math.random()*6000); }                  // moment was bad — try again soon, not in a minute
setTimeout(tipTick, 9000+Math.random()*5000);

(function scheduleBlink(){ setTimeout(()=>{ if(!micLive&&!isAngry()&&state==='perch'&&!toot.classList.contains('sing')){ toot.classList.add('blink'); setTimeout(()=>{toot.classList.remove('blink');
  if(Math.random()<0.18) setTimeout(()=>{ if(micLive||isAngry()||state!=='perch')return; toot.classList.add('blink');setTimeout(()=>toot.classList.remove('blink'),120);},170); },130); } scheduleBlink(); }, 2400+Math.random()*3800); })();

// public controls
window.flyTo=(el,style,opts)=>flyLeg({el}, Object.assign({style:style||'swoop', land:true}, opts||{})); // rx/ry come from the perch's data attrs
window.flyRandom=()=>{ if(busy||micLive)return; const v=perches().filter(visible).filter(e=>e!==perchedOn); flyTo(v[Math.floor(Math.random()*v.length)]||perches()[0]); };
// marketing-weighted perch choice: value (data-perch-pri) beats raw distance, and he
// avoids re-landing where he already sits so attention keeps moving to fresh CTAs.
function bestPerch(fx,fy){ const cand=perches().filter(visible).filter(el=>el!==perchedOn);
  let best=null, bs=-1;
  cand.forEach(el=>{ const r=el.getBoundingClientRect();
    const d=Math.hypot(r.left+r.width/2-fx, r.top+r.height/2-fy);
    const pri=+(el.dataset.perchPri||1);
    const score=pri/(1+d/420);
    if(score>bs){bs=score;best=el;} });
  return best; }
function nearestPerchByPage(){ const mid=scrollY+innerHeight/2; let best=null,bd=1e9;
  perches().forEach(el=>{ const r=el.getBoundingClientRect(), cy=r.top+scrollY+r.height/2, d=Math.abs(cy-mid);
    if(d<bd){bd=d;best=el;} }); return best; }
window.callToot=async()=>{ if(busy||micLive)return; busy=true; setBtns(true);
  try{
    fxAfter(fxWiggle,1500);
    await flyLeg({x:innerWidth*0.62,y:innerHeight*0.44},{style:'sweep',endPose:'hover'});
    await hoverBob(1000);
    if(micLive) return;
    // choose AFTER the hover, against the viewport the user is actually looking at now
    const origin=perchedOn;
    const screen=rigScreenPos();
    let best=bestPerch(screen.x+BW/2,screen.y+BW/2);
    if(!best){ best=nearestPerchByPage(); if(best===origin) best=null;
      if(best){ best.scrollIntoView({behavior:'smooth',block:'center'}); await wait(650); } }
    const _fb=best||perches().filter(visible).filter(function(el){return el!==origin;})[0]||perches()[0]; if(!_fb){ doWave(true); return; } await flyLeg({el:_fb},{style:'swoop',land:true});
    if(micLive||state!=='perch'||!perchedOn) return; // hush aborted a leg above: never resurrect the wave/sing tail on a mid-air pin
    doWave(true); await wait(1400);
    if(micLive) return;
    doSing(true); await wait(900);
  } finally { busy=false; setBtns(false); } };

perches().forEach(el=>el.addEventListener('click',()=>{ if(!busy&&!micLive&&!isAngry()) flyTo(el); }));
let _taps=[], _pester=0, _pesterT=0;
wrap.addEventListener('click',()=>{ if(micLive||state!=='perch')return; // no mid-flight reactions
  if(isAngry()){ angryUntil=performance.now()+2000; actUntil=angryUntil; armAngryEnd(); return; }
  if(busy)return;
  toot.classList.remove('fx-hop'); // interrupting a flutter-hop must not leave flight wings stuck on
  const n=performance.now();
  if(isBranchSeat()){
    branchTapTimes=branchTapTimes.filter(function(t){ return n-t<850; });
    branchTapTimes.push(n);
    if(branchTapTimes.length>=4){ branchTapTimes=[]; enterAngry(); return; }
    if(pendingBranchClick) return;
    pendingBranchClick=setTimeout(singFromBranch,260);
    return;
  }
  branchTapTimes=[];
  clearPendingBranchSong();
  _taps=_taps.filter(t=>n-t<1300); _taps.push(n);
  if(_taps.length>=3){ _taps=[]; actUntil=n+1500; // rapid taps: ecstatic — and it REPLACES any running act (never stacks)
    clearInterval(singT); toot.classList.remove('sing','wave'); if(typeof tnClearNotes==='function')tnClearNotes(); setBeak('closed');
    flashEyes('wide',1300); rxExcited(); return; }
  if(n<actUntil){ // mid-performance: extra clicks are swallowed; pester him enough and he gets miffed
    if(n-_pesterT>5000)_pester=0; _pesterT=n;
    if(++_pester>=3){ _pester=0; flashEyes('angry',1400); emFluff(); actUntil=Math.max(actUntil,n+1500); }
    return; }
  actUntil=n+1500;
  if(perchedOn&&perchedOn.dataset.sing) doSing(true); else doWave(true); rxClickReact(); });
wrap.addEventListener('keydown',e=>{ if(!e.repeat&&(e.key==='Enter'||e.key===' ')){ e.preventDefault(); primeAudio(); wrap.click(); } });

const range=document.getElementById('sizerange');
range.addEventListener('input',()=>{ setSize(+range.value); if(state==='perch'&&perchedOn) rideNow(); });

window.toggleMic=()=>{ micLive=!micLive; document.body.classList.toggle('hush',micLive);
  const b=document.getElementById('micbtn'); b.dataset.on=micLive?'1':'0'; b.textContent=micLive?'🎙 Hushed':'🎙 Mic';
  actUntil=0; sndUntil=0; clearTimeout(eyeT); clearTimeout(beakT); hideTip(); // gates + face restores + tips never straddle a mic toggle
  clearPendingBranchSong(); clearNavMouth(); clearAnger(false); branchTapTimes=[];
  try{ if(window.SaifToot&&window.SaifToot.cancelReactions) window.SaifToot.cancelReactions(false); }catch(e){}
  if(micLive){ clearInterval(singT); setBeak('closed'); setEyes('open'); toot.classList.remove('flying','flaring','sing','wave','land'); hushClearFX();
    scrollTo({top:scrollY,left:scrollX,behavior:'instant'}); // abort any in-flight smooth scroll (callToot scrollIntoView) so the page isn't gliding during the take
    try{ ulk.pause(); }catch(e){} // media session off while recording
    /* Keep the gesture-unlocked AudioContext alive through the take. Closing it
       here meant an auto-stopped recording reached its score with AC === null:
       Toot's mouth moved, but the tier song had nowhere to play. The voice bus
       is hard-muted instead, so scheduled notes cannot bleed into the mic and
       the same unlocked context is ready the instant recording ends. */
    try{ if(AENG&&typeof AENG.mute==='function') AENG.mute(true); }catch(e){}
    clearRigTransition(); resetRigPose(); state='perch';
    if(!perchedOn) freeAnchor=rigPageAnchor(); // hush mid-flight: pin him to the page, not the screen
    apply(); }
  else {
    if(state==='perch') toot.classList.add('idle');
    primeAudio();
    try{ if(AENG&&typeof AENG.mute==='function') AENG.mute(false); }catch(e){}
    unlock();
  } // un-hush: resume breathing + re-arm iOS media session
  const bb=document.getElementById('micbtn'); if(bb)bb.setAttribute('aria-pressed',micLive?'true':'false'); };

// stay put where he last landed — he only relocates when you Call him.
// just a gentle occasional wave so he feels alive without leaving his spot.
// One calm loop. This one does ONLY a subtle eye glance (no body movement) so it
// cannot stack body emotes with emInit, which is the sole source of the occasional
// body-language move. Both stand down during the lesson.
setInterval(()=>{ if(micLive||busy||isAngry()||window.__tootTeaching||state!=='perch'||!perchedOn||!visible(perchedOn))return;
if(performance.now()<actUntil)return;
if(Math.random()<0.28) flashEyes('glance',900); }, 16000);

// audio (synth; created on first gesture so mobile doesn't block it)
let AC=null, _acCT=0, _acWall=0;
// iOS silent-switch fix: playing ANY media element flips the audio session to
// "playback", which ignores the ringer switch — so WebAudio becomes audible too.
const ulk=document.createElement('audio');
ulk.src='data:audio/wav;base64,UklGRuQDAABXQVZFZm10IBAAAAABAAEAQB8AAIA+AAACABAAZGF0YcADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA='; ulk.setAttribute('playsinline',''); ulk.preload='auto'; ulk.volume=0.01;
function unlock(){ if(micLive)return; try{ ulk.currentTime=0; const pr=ulk.play(); if(pr&&pr.catch)pr.catch(()=>{}); }catch(e){} }
function primeAudio(){
  if(micLive) return false;
  var AudioCtor=window.AudioContext||window.webkitAudioContext;
  if(!AudioCtor) return false;
  AC=AC||new AudioCtor();
  if(AC.state!=='running') AC.resume();
  _acCT=AC.currentTime; _acWall=performance.now();
  return true;
}
addEventListener('pointerdown',e=>{ primeAudio();
  const mb=document.getElementById('micbtn'); if(!(mb&&e.target&&mb.contains(e.target))) unlock(); },{passive:true});
addEventListener('keydown',function(e){
  if(!e.repeat&&(e.key==='Enter'||e.key===' ')) primeAudio();
},{passive:true});
// returning to the tab: iOS often leaves the context interrupted/stuck — resume + re-unlock
document.addEventListener('visibilitychange',()=>{ if(document.visibilityState==='visible'){
  if(AC&&AC.state!=='running'){ const pr=AC.resume(); if(pr&&pr.catch)pr.catch(()=>{}); } if(!micLive) unlock(); } });
const ac=()=>{ if(!AC) return null;
  if(AC.state!=='running'){ const pr=AC.resume(); if(pr&&pr.catch)pr.catch(()=>{}); }
  else { const n=performance.now(); // dead-clock watchdog: "running" but frozen = zombie context (iOS after interruption)
    if(AC.currentTime===_acCT){ if(AC.currentTime>0&&_acWall&&n-_acWall>1500){ try{ const _a=AC; AC=null; _a.close(); }catch(e){} return AC; } }
    else { _acCT=AC.currentTime; _acWall=n; } }
  return AC; };
function blip(f,t,d,g,type){const a=ac();if(!a)return;const o=a.createOscillator(),gn=a.createGain();o.type=type||'triangle';o.frequency.setValueAtTime(f,t);
  gn.gain.setValueAtTime(0,t);gn.gain.linearRampToValueAtTime(g,t+.02);gn.gain.exponentialRampToValueAtTime(1e-4,t+d);o.connect(gn).connect(a.destination);o.start(t);o.stop(t+d+.02);}
// one voice at a time: short cues skip while anything is sounding; songs reserve their whole duration.
// Sounds come from the makeTootAudio engine (appended below); blip() remains only as a fallback voice.
let AENG=null;
function engine(){ if(!AENG&&typeof makeTootAudio==='function') AENG=makeTootAudio(()=>ac()); return AENG; }
function chirp(){ if(micLive||performance.now()<sndUntil)return 0;const a=ac();if(!a)return 0;sndUntil=performance.now()+300;
  const e=engine(); if(e){e.chirp();return 300;} const t=a.currentTime+.02;blip(1400,t,.1,.08);blip(1900,t+.1,.12,.07);return 300;}
function peep(){ if(micLive||performance.now()<sndUntil)return;const a=ac();if(!a)return;sndUntil=performance.now()+260;
  const e=engine(); if(e){e.peep();return;} const t=a.currentTime+.01;blip(1750,t,.12,.09,'sine');}
function whoosh(){ if(micLive||performance.now()<sndUntil)return;const a=ac();if(!a)return;sndUntil=performance.now()+340;
  const e=engine(); if(e){e.whoosh();return;} const t=a.currentTime;blip(520,t,.16,.05,'sine');}
function excitedSnd(){ if(micLive||performance.now()<sndUntil)return;const a=ac();if(!a)return;sndUntil=performance.now()+750;
  const e=engine(); if(e){e.excited();return;} const t=a.currentTime+.03;[784,988,1175,1568].forEach((f,i)=>blip(f,t+i*.08,.15,.06,'sine'));}
// pick + play a song; returns its length in ms (0 if muted/gated). shortOnly = tip pop-up songs.
function singSong(shortOnly){ if(micLive||performance.now()<sndUntil)return 0;const a=ac();if(!a)return 0;
  // The three score songs are played BY NAME on a real result — never at random.
  const e=engine();
  if(e&&e.songs&&e.songs.length){ let pool=e.songs.filter(s=>!s.scoreOnly); if(shortOnly) pool=pool.filter(s=>s.short);
    const mq=pool.filter(s=>s.maqam); if(mq.length>1&&Math.random()<0.6) pool=mq; // he favors the maqamat (only when the pool keeps variety)
    const s=pool[Math.floor(Math.random()*pool.length)]||e.songs[0];
    sndUntil=performance.now()+s.dur*1000+150; s.play(); return s.dur*1000; }
  sndUntil=performance.now()+1650; const P=[587,622,698,784,698,622,587,698];let t=a.currentTime+.05;P.forEach((f,i)=>{blip(f,t,i===P.length-1?.4:.2,.08);t+=.18;}); return 1650; }
function tipSong(){ return singSong(true); }
function chirpMelody(){ return singSong(false); }

/* entrance handled by theme glue */

// ===== Toot FX modules (generated): tn notes / em emotes / rx reactions / fx flourishes + hushClearFX + initFX =====
/* ===================================================================
   TOOT FX — integrated behaviour (append verbatim inside the rig <script>).
   4 modules (tn/em/rx/fx) + master hushClearFX() + initFX(). Reads all
   rig globals (toot,pos,BW,micLive,state,busy,perchedOn,visible,ac,blip,
   chirp,peep…) already in scope. Self-runs initFX() on the last line.
   =================================================================== */

// ===== MODULE tn: singing music notes + sing body-language =====
// Musical glyphs: eighth, beamed eighths, quarter, beamed sixteenths, + two emoji notes.
const TN_GLYPHS=['♪','♫','♩','♬','♪','♫','🎵','🎶'];
let tnStream=null, tnBodyT=null;
const tnNotes=new Set();   // live particle nodes
const tnTimers=new Set();  // per-note safety-net timeout ids (so cleanup can kill them ALL)

// spawn a single floating note centered on (cx,cy), in Toot's current space
function tnSpawnOne(cx,cy){
  if(micLive)return;
  const layer=document.getElementById('toot-layer');
  if(!layer||tnNotes.size>=10)return;               // strict <=10 concurrent (contract)
  const viewportSpace=effectsUseViewportSpace();
  const host=viewportSpace?layer:document.body;
  const fx=viewportSpace?cx:cx+scrollX, fy=viewportSpace?cy:cy+scrollY;
  const el=document.createElement('div');
  el.className='tn-note '+['tn-c1','tn-c2','tn-c3'][Math.floor(Math.random()*3)]+(viewportSpace?'':' toot-page-fx');
  el.textContent=TN_GLYPHS[Math.floor(Math.random()*TN_GLYPHS.length)];
  const dir=Math.random()<0.5?-1:1;
  const rise=-(92+Math.random()*48);        // rise 92..140px
  const sway=(10+Math.random()*10)*dir;      // left-right sway
  const drift=(Math.random()*22-11);         // small net horizontal drift
  const rot=(12+Math.random()*22)*dir;       // final rotation
  const dur=(1.5+Math.random()*0.7);         // 1.5..2.2s life
  const size=(20+Math.random()*14);          // 20..34px glyph
  el.style.cssText='left:'+(fx+(Math.random()*14-7)).toFixed(1)+'px;top:'+fy.toFixed(1)+'px;'
    +'font-size:'+size.toFixed(1)+'px;'
    +'--tn-rise:'+rise.toFixed(1)+'px;--tn-sway:'+sway.toFixed(1)+'px;'
    +'--tn-drift:'+drift.toFixed(1)+'px;--tn-rot:'+rot.toFixed(1)+'deg;'
    +'animation-duration:'+dur.toFixed(2)+'s';
  let tid=0;
  const done=function(){
    el.removeEventListener('animationend',done);
    if(tid){ clearTimeout(tid); tnTimers.delete(tid); }   // kill this note's own safety timer
    tnNotes.delete(el);
    if(el.isConnected) el.remove();
  };
  el.addEventListener('animationend',done);
  // safety net in case animationend is missed (e.g. tab backgrounded); TRACKED so cleanup clears it
  tid=setTimeout(function(){ tnTimers.delete(tid); if(el.isConnected){ tnNotes.delete(el); el.remove(); } }, dur*1000+450);
  tnTimers.add(tid);
  tnNotes.add(el);
  host.appendChild(el);
}

// public: fire a one-off burst of n notes (clamped 1..10) at a screen point
function tnBurstNotes(n,cx,cy){
  if(micLive)return;
  const k=Math.max(1,Math.min(10,n|0));
  for(let i=0;i<k;i++) tnSpawnOne(cx,cy);
}

// public: run the note stream + sing body-language for durationMs, then self-clean
function tnSingFX(ms){
  if(micLive)return;
  const dur=ms>0?ms:1500;
  toot.classList.add('tn-singing');
  clearInterval(tnStream); clearTimeout(tnBodyT);
  const total=6+Math.floor(Math.random()*4);   // 6..9 notes across the sing
  let n=0;
  const emit=function(){
    if(micLive){ tnClearNotes(); return; }
    const screen=rigScreenPos(), cx=screen.x+BW*0.5, cy=screen.y+BW*0.46;    // live beak screen pos
    tnSpawnOne(cx,cy);
    if(n>0 && Math.random()<0.28 && tnNotes.size<9) tnSpawnOne(cx+(Math.random()*18-9),cy-6);
    if(++n>=total){ clearInterval(tnStream); tnStream=null; }
  };
  emit();
  tnStream=setInterval(emit, Math.max(120, dur/total));
  tnBodyT=setTimeout(function(){ clearInterval(tnStream); tnStream=null; toot.classList.remove('tn-singing'); tnBodyT=null; }, dur+140);
}

// single cleanup: freeze ALL timers, drop the body class, remove every live note
function tnClearNotes(){
  clearInterval(tnStream); tnStream=null;
  clearTimeout(tnBodyT); tnBodyT=null;
  tnTimers.forEach(function(id){ clearTimeout(id); }); tnTimers.clear();  // per-note safety timers
  if(typeof toot!=='undefined'&&toot) toot.classList.remove('tn-singing');
  tnNotes.forEach(function(el){ try{ el.remove(); }catch(e){} });
  tnNotes.clear();
}

/* ===== Toot Module 2 — idle emote repertoire (body-language personality) ===== */
/* Pure CSS-class body language: crest / tail / folded-wing / whole-body moves ONLY.
   Never animates .p-head, .eyes-* or .beak-* independently — in the rig the head, eyes,
   beak and crest are SEPARATE sibling groups, so head-only motion would tear the face
   apart (visually confirmed). "Head" moves are whole-.toot tilts pivoting at the feet, so
   the face stays rigid. Spawns NO particles — timers + toot classes are the whole footprint,
   so the particle-removal clause of the cleanup contract is N/A. */
let emBusy=false, emClass=null, emT=null, emIdle=null;
const EM_CLASSES=['em-headtilt','em-lookaround','em-crestflick','em-tailflick','em-preen','em-fluff','em-hop','em-stretch'];
const emReduce=(window.matchMedia?matchMedia('(prefers-reduced-motion:reduce)'):null);

// airborne / land guard so whole-body moves never fight the flight or landsquash transforms on .toot
function emCanPlay(bodywide){
  if(micLive||emBusy) return false;
  const c=toot.classList;
  if(c.contains('flying')||c.contains('flaring')) return false;
  if(bodywide && c.contains('land')) return false;   // don't fight the whole-svg landsquash
  return true;
}
// add ONE emote class, auto-remove it on a timer (strictly one emote at a time)
function emRun(cls,ms,bodywide){
  if(micLive||isAngry()) return;               // mic-hush and anger own the full pose
  if(emReduce && emReduce.matches) return;     // reduced-motion honoured at the single choke point
  if(!emCanPlay(bodywide)) return;             // not airborne/landing, not already emoting
  if(bodywide && performance.now()<actUntil) return; actUntil=Math.max(actUntil,performance.now()+ms+120); // one performance at a time
  emBusy=true; emClass=cls;
  toot.classList.add(cls);
  clearTimeout(emT);
  emT=setTimeout(()=>{ toot.classList.remove(cls); emClass=null; emT=null; emBusy=false; }, ms);
}

// ---- public emotes (pure body language; every entry early-returns on micLive) ----
// bodywide=true => transforms the whole .toot svg (must respect land/flight guards)
function emHeadTilt(){ if(micLive)return; emRun('em-headtilt',1150,true); }    // whole-body curious cock + crest lead
function emLookAround(){ if(micLive)return; emRun('em-lookaround',1600,true); } // whole-body swivel: scan left then right
function emCrestFlick(){ if(micLive)return; emRun('em-crestflick',760,false); } // alert crest snaps up (crest only)
function emTailFlick(){ if(micLive)return; emRun('em-tailflick',950,false); }   // tail wag (tail only)
function emPreen(){ if(micLive)return; emRun('em-preen',1400,true); }           // whole-body forward tuck + LEFT wing groom
function emFluff(){ if(micLive)return; emRun('em-fluff',700,true); }            // whole-body fluff shiver
function emHop(){ if(micLive)return; emRun('em-hop',720,true); }                // springy vertical hop
function emStretch(){ if(micLive)return; emRun('em-stretch',1300,true); }       // one-wing (LEFT) + tail-fan stretch

// weighted random idle emote — keeps Toot curious & alive while perched
function emIdleEmote(){
  if(micLive||busy||isAngry()||state!=='perch'||!perchedOn||!visible(perchedOn)) return;
  if(window.__tootTeaching) return;   // no ambient body language during the lesson (he rides the card)
  // emHop (a springy vertical hop) removed from the ambient pool — it was the
  // "hopping for no reason". Left as a function for scripted use.
  const table=[[emHeadTilt,22],[emLookAround,16],[emCrestFlick,18],[emTailFlick,16],[emPreen,14],[emFluff,14]];
  let tot=0; for(const it of table) tot+=it[1];
  let r=Math.random()*tot;
  for(const it of table){ if((r-=it[1])<0){ it[0](); return; } }
}

// self-rescheduling ambient loop (randomised cadence so it never feels metronomic).
// Every beat no-ops while hushed but ALWAYS reschedules, so the loop auto-resumes after mic-off.
// NOTE: emInit (arm) and emStop (cleanup) intentionally do NOT early-return on micLive — they are the
// lifecycle hooks the rig itself runs during hush, and emStop must be able to re-arm a dormant scheduler.
function emInit(){
  clearTimeout(emIdle);
  (function emBeat(){
    emIdle=setTimeout(()=>{
      if(!micLive && Math.random()<0.5) emIdleEmote();
      emBeat();
    }, 12000+Math.random()*9000);   /* was 5.2-9.4s — far too frequent */
  })();
}

// cleanup — instant freeze the moment the mic turns on: clears every timer, strips every
// class this module added, re-arms one clean dormant scheduler. (No particles to remove.)
function emStop(){
  clearTimeout(emT); emT=null;
  if(emClass){ toot.classList.remove(emClass); emClass=null; }
  for(const c of EM_CLASSES) toot.classList.remove(c);
  emBusy=false;
  emInit(); // re-arm one clean, dormant scheduler (stays silent until mic-off, then auto-resumes)
}

/* ===== Module rx-reactions: taps -> delighted body-language + particle bursts, plus a subtle cursor gaze ===== */
let rxTimers=new Set(), rxNodes=new Set();
let rxGx=0,rxGy=0,rxTx=0,rxTy=0,rxRAF=0,rxClicks=0,rxLastClick=0,rxGazeReady=false,rxFaceEls=[];
const rxReduce=!!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches);
/* face parts are SEPARATE svg groups; [selector, placeScaleX, placeScaleY] converts a desired ON-SCREEN pixel
   offset into each part's own LOCAL units (delta/scale), so head+eyes+beak translate by identical screen px and
   lean as ONE coherent cluster (no detach). Scale factors verified 1:1 against the rig's placement transforms. */
const rxFaceDef=[['.p-head',0.60,0.60],['.eyes-open .an',0.36,0.36],['.eyes-happy .an',0.36,0.85],
  ['.eyes-glance .an',0.36,0.36],['.eyes-joy .an',0.316,0.316],['.eyes-angry .an',0.338,0.338],['.eyes-wide .an',0.31,0.31],
  ['.beak-closed .an',0.17,0.17],['.beak-med .an',0.185,0.185],['.beak-open .an',0.20,0.20],
  ['.beak-smile .an',0.157,0.157],['.beak-half .an',0.185,0.185],['.beak-big .an',0.19,0.19],['.beak-broad .an',0.19,0.19]];

/* translate-only look toward the cursor; set on the INNER .an groups so it COMPOSES with the outer placement
   attribute (never fights it). Pure translation = body-language head-lean, never a squash/squint/mouth-morph. */
function rxApplyGaze(sh,sv){ for(const f of rxFaceEls){ f[0].style.transform='translate('+(sh/f[1]).toFixed(2)+'px,'+(sv/f[2]).toFixed(2)+'px)'; } }
function rxResetGaze(){ for(const f of rxFaceEls){ if(f[0]) f[0].style.transform=''; } }
function rxGazeLoop(){ rxRAF=0;
  /* force the target to rest whenever hushed / airborne / unperched, so an in-flight ease can never hold a lean */
  if(micLive||isAngry()||state!=='perch'||!perchedOn){ rxTx=0; rxTy=0; }
  rxGx+=(rxTx-rxGx)*0.18; rxGy+=(rxTy-rxGy)*0.18; rxApplyGaze(rxGx,rxGy);
  if(Math.abs(rxGx-rxTx)>0.15||Math.abs(rxGy-rxTy)>0.15){ rxRAF=requestAnimationFrame(rxGazeLoop); }
  else { rxGx=rxTx; rxGy=rxTy; if(rxTx===0&&rxTy===0) rxResetGaze(); else rxApplyGaze(rxGx,rxGy); } }
function rxKick(){ if(!rxRAF && (Math.abs(rxGx-rxTx)>0.15||Math.abs(rxGy-rxTy)>0.15)) rxRAF=requestAnimationFrame(rxGazeLoop); }
function rxOnMove(e){
  if(e&&e.pointerType==='touch') return;               /* touch: no hover-gaze; don't wake rAF on scroll-drags */
  if(micLive||isAngry()) return;                       /* MIC-HUSH / anger: perfectly still */
  if(state!=='perch'||!perchedOn){ rxTx=0; rxTy=0; rxKick(); return; }
  const screen=rigScreenPos(), cx=screen.x+BW*0.5, cy=screen.y+BW*0.5, dx=e.clientX-cx, dy=e.clientY-cy, R=1.6*BW;
  if(Math.hypot(dx,dy)>R){ rxTx=0; rxTy=0; }
  else { const max=rxReduce?BW*0.02:BW*0.045;         /* subtle: <=4.5% BW so the head/crest seam never parts */
    rxTx=Math.max(-1,Math.min(1,dx/R))*max; rxTy=Math.max(-1,Math.min(1,dy/R))*max*0.6; }
  rxKick(); }
function rxOnLeave(){ if(micLive) return; rxTx=0; rxTy=0; rxKick(); }
/* public: idempotent, pure setup — installs cheap listeners only; the heavy work stays rAF-gated */
function rxGazeInit(){ if(rxGazeReady) return; rxGazeReady=true;
  rxFaceEls=rxFaceDef.map(d=>[document.querySelector(d[0]),d[1],d[2]]).filter(d=>d[0]);
  addEventListener('pointermove',rxOnMove,{passive:true});
  document.addEventListener('pointerleave',rxOnLeave);
  addEventListener('blur',rxOnLeave); }

function rxSpawn(kind){ if(micLive) return; if(rxNodes.size>28) return;   /* bounded pool caps compositor layers */
  const layer=document.getElementById('toot-layer'); if(!layer) return;
  const viewportSpace=effectsUseViewportSpace();
  const host=viewportSpace?layer:document.body;
  const cfg = kind==='heart' ? {g:['💛','💛','♥','♡'],n:7,cls:'rx-heart',spread:1.5,up:0.9,sz:0.15}
    : kind==='spark2' ? {g:['✨','✦','✧','·','⭐'],n:5,cls:'rx-spark',spread:2.8,up:0.6,sz:0.12}
    : {g:['✨','✦','✧','⭐','·'],n:9,cls:'rx-spark',spread:2.6,up:0.6,sz:0.13};
  const screen=rigScreenPos(), cx=screen.x+BW*0.5, cy=screen.y+BW*0.40;            /* around the beak/head */
  for(let i=0;i<cfg.n;i++){
    const d=document.createElement('div'); d.className='rx-particle '+cfg.cls+(viewportSpace?'':' toot-page-fx');
    d.textContent=cfg.g[(Math.random()*cfg.g.length)|0];
    const ang=-Math.PI/2+(Math.random()-0.5)*cfg.spread, r0=BW*(0.05+Math.random()*0.22), dist=BW*(0.35+Math.random()*0.5);
    const sx=cx+Math.cos(ang)*r0, sy=cy+Math.sin(ang)*r0*0.7;
    const gx=Math.cos(ang)*dist+(Math.random()-0.5)*BW*0.15, gy=Math.sin(ang)*dist*cfg.up-BW*(0.15+Math.random()*0.2);
    d.style.left=(sx+(viewportSpace?0:scrollX)).toFixed(1)+'px'; d.style.top=(sy+(viewportSpace?0:scrollY)).toFixed(1)+'px';
    d.style.fontSize=(BW*cfg.sz*(0.7+Math.random()*0.7)).toFixed(1)+'px';
    d.style.setProperty('--rx-dx',gx.toFixed(1)+'px'); d.style.setProperty('--rx-dy',gy.toFixed(1)+'px');
    d.style.setProperty('--rx-sc',(0.85+Math.random()*0.8).toFixed(2)); d.style.setProperty('--rx-rot',(((Math.random()-0.5)*70)|0)+'deg');
    d.style.animationDuration=(0.8+Math.random()*0.6).toFixed(2)+'s'; d.style.animationDelay=(Math.random()*0.14).toFixed(2)+'s';
    host.appendChild(d); rxNodes.add(d);
    let fb=0; const done=()=>{ clearTimeout(fb); rxTimers.delete(fb); d.remove(); rxNodes.delete(d); };
    d.addEventListener('animationend',done,{once:true});                 /* normal path clears its own fallback */
    fb=setTimeout(()=>{ rxTimers.delete(fb); if(d.isConnected) d.remove(); rxNodes.delete(d); },1800); rxTimers.add(fb);
  } }

/* public: delighted reaction to a tap; 3 rapid taps (<1.2s apart) escalate to rxExcited */
function rxClickReact(){ if(micLive) return;
  const now=performance.now(); rxClicks=(now-rxLastClick<1200)?rxClicks+1:1; rxLastClick=now;
  if(rxClicks>=3){ rxClicks=0; rxExcited(); return; }
  toot.classList.remove('rx-bounce'); void toot.offsetWidth; toot.classList.add('rx-bounce');
  const id=setTimeout(()=>{ toot.classList.remove('rx-bounce'); rxTimers.delete(id); },700); rxTimers.add(id);
  rxSpawn('heart');
  if(typeof chirp==='function') chirp(); }  /* base wrapper self-gates (one voice at a time) + engine sound */

/* public: bigger celebration — rapid hops + double sparkle burst + ascending arpeggio */
function rxExcited(){ if(micLive) return; rxClicks=0;
  toot.classList.remove('rx-bounce','rx-hop'); void toot.offsetWidth; toot.classList.add('rx-hop');
  const id=setTimeout(()=>{ toot.classList.remove('rx-hop'); rxTimers.delete(id); },1300); rxTimers.add(id); /* 1300>1.26s tail wag */
  rxSpawn('spark');
  const id2=setTimeout(()=>{ rxTimers.delete(id2); rxSpawn('spark2'); },320); rxTimers.add(id2);
  if(typeof excitedSnd==='function') excitedSnd(); }  /* base wrapper self-gates + engine flourish */

/* single cleanup — called the instant the mic goes live: freezes + erases EVERYTHING this module made */
function rxClear(){
  for(const id of rxTimers) clearTimeout(id); rxTimers.clear();
  if(rxRAF) cancelAnimationFrame(rxRAF); rxRAF=0; rxGx=0; rxGy=0; rxTx=0; rxTy=0; rxResetGaze();
  toot.classList.remove('rx-bounce','rx-hop');
  for(const d of rxNodes){ if(d&&d.remove) d.remove(); } rxNodes.clear();
  rxClicks=0; rxLastClick=0; }

/* ===== Module 4 — flight & landing flourishes (fx) =====
   Additive helpers layered on the engine. No engine fn is redefined; no reserved
   name is declared. Every public entry early-returns on micLive; fxStop() is the
   single cleanup (clears ALL timers + strips ALL added classes; no particles made). */

/* durations match each effect's LONGEST animation exactly, so class removal lands
   the instant the motion settles. Critical for fx-hop: the spread-wing reveal is
   governed by class presence (CSS display can't tween), so an over-long timer would
   leave the flight wings spread on a resting bird for the extra ms — a visible pop. */
const FX_LAND_MS=600, FX_HOP_MS=700, FX_WIG_MS=750;

/* one Set tracks every timer this module opens, so fxStop can cancel them all. */
const fxTimers=new Set();
function fxAfter(fn,ms){ const id=setTimeout(()=>{ fxTimers.delete(id); fn(); }, ms); fxTimers.add(id); return id; }

/* (a) touchdown flourish: tail fan + folded-wing flutter. Part-level only, so it
   rides ON TOP of the .land landsquash. Safe to restart (reflow re-triggers). */
function fxLandFlourish(){ if(micLive) return;
  toot.classList.remove('fx-landjoy'); void toot.offsetWidth; toot.classList.add('fx-landjoy');
  fxAfter(()=>toot.classList.remove('fx-landjoy'), FX_LAND_MS); }

/* (b) idle flutter-hop: spread flight wings + small hop, no flyLeg. Perch-only.
   Guards out .land (owns .toot transform) AND .wave (owns the .p-wingfR arm inside
   .perch-only, which this hop would hide) so it never blanks an in-progress wave. */
function fxFlutterHop(force){ if(micLive) return false;
  if(busy || state!=='perch' || !perchedOn) return false;
  if(toot.classList.contains('land') || toot.classList.contains('wave') || toot.classList.contains('fx-hop')) return false;
  if(!force&&performance.now()<actUntil) return false;
  actUntil=Math.max(actUntil,performance.now()+FX_HOP_MS+120); // one performance at a time
  toot.classList.add('fx-hop');
  fxAfter(()=>toot.classList.remove('fx-hop'), FX_HOP_MS);
  return true; } // silent: ambient moves never make noise

/* (c) mid-air wiggle: quick bank/roll + crest pop. Airborne only (never on .toot
   while .land owns the .toot transform). */
function fxWiggle(){ if(micLive) return;
  if(state==='perch' || toot.classList.contains('land') || toot.classList.contains('fx-wig')) return;
  toot.classList.remove('fx-wig'); void toot.offsetWidth; toot.classList.add('fx-wig');
  fxAfter(()=>toot.classList.remove('fx-wig'), FX_WIG_MS); }

/* single cleanup: kill EVERY tracked timer, strip EVERY class this module can add.
   No particle nodes are created, so there is nothing else to remove. */
function fxStop(){ fxTimers.forEach(id=>clearTimeout(id)); fxTimers.clear();
  toot.classList.remove('fx-landjoy','fx-hop','fx-wig'); }

/* guarded load-time init: expose for manual QA / the verify harness, mirroring the
   engine's own window.flyTo/window.callToot convention. No behavior is invoked here. */
window.fxLandFlourish=fxLandFlourish; window.fxFlutterHop=fxFlutterHop;
window.fxWiggle=fxWiggle; window.fxStop=fxStop;

/* ===================================================================
   MASTER CLEANUP — call this in toggleMic's hush branch. Runs every
   module's cleanup, each isolated in its own try/catch so one throwing
   can never leave another module's timers/particles/classes alive.
   emStop() re-arms a DORMANT emote scheduler (safe: it no-ops on micLive
   and auto-resumes when the mic goes off).
   =================================================================== */
function hushClearFX(){
  try{ tnClearNotes(); }catch(e){}   // notes + sing body-language
  try{ emStop(); }catch(e){}         // idle emotes (+ re-arm dormant scheduler)
  try{ rxClear(); }catch(e){}        // tap reactions, gaze, particles
  try{ fxStop(); }catch(e){}         // flight/landing flourishes
}

/* ===================================================================
   MASTER LOAD-INIT — arms every module's load-time listeners exactly
   once. emInit() (ambient emote scheduler, fires nothing at load, only
   schedules) + rxGazeInit() (idempotent pointermove gaze listener).
   Module 4's window.fx* exposure already ran inline above. Each wrapped
   so one failure can't block the rest. Self-runs on the last line.
   =================================================================== */
function initFX(){
  try{ emInit(); }catch(e){}         // ambient idle-emote scheduler (dormant during hush)
  try{ rxGazeInit(); }catch(e){}     // cursor-gaze pointermove listener (rAF-gated)
}
initFX();

// ===== Toot voice engine (generated): makeTootAudio =====
function makeTootAudio(getCtx){
  // Toot voice, final cut: "Velvet Bulbul" - real songbird phrasing, softened.
  // Every note is a liquid frequency glide (never a flat tone) with a
  // whisper of band-passed breath under it; everything sums into one
  // warm master chain: gain -> dark highshelf + lowpass -> a small
  // feedback-delay "air" so the bird sings in a soft room, not a chip.
  // Two songs are grafted in from the sibling engines and re-sung in
  // this voice: 'Dewdrop Waltz' (Music-Box Bulbul) and 'Sun Through
  // Canopy' (Glade), replacing Rain Hop and Moonfeather Lull.
  var lastCtx = null;
  var bus = null;       // master voice bus (rebuilt per context)
  var noiseBuf = null;  // shared breath/whoosh noise
  var muted = false;    // recording interlock; context remains gesture-unlocked

  function ensure(ctx){
    if(ctx === lastCtx && bus){ return; }
    lastCtx = ctx;
    var len = Math.floor(ctx.sampleRate * 1.0);
    noiseBuf = ctx.createBuffer(1, len, ctx.sampleRate);
    var ch = noiseBuf.getChannelData(0);
    for(var i = 0; i < len; i++){ ch[i] = Math.random() * 2 - 1; }
    bus = ctx.createGain();
    bus.gain.value = muted ? 0 : 0.45;
    var shelf = ctx.createBiquadFilter();
    shelf.type = 'highshelf';
    shelf.frequency.value = 3600;
    shelf.gain.value = -7;
    var lop = ctx.createBiquadFilter();
    lop.type = 'lowpass';
    lop.frequency.value = 7000;
    lop.Q.value = 0.4;
    bus.connect(shelf);
    shelf.connect(lop);
    lop.connect(ctx.destination);
    var dly = ctx.createDelay(0.5);
    dly.delayTime.value = 0.13;
    var fbLp = ctx.createBiquadFilter();
    fbLp.type = 'lowpass';
    fbLp.frequency.value = 2600;
    fbLp.Q.value = 0.4;
    var fb = ctx.createGain();
    fb.gain.value = 0.21;
    var wet = ctx.createGain();
    wet.gain.value = 0.11;
    lop.connect(dly);
    dly.connect(fbLp);
    fbLp.connect(fb);
    fb.connect(dly);
    dly.connect(wet);
    wet.connect(ctx.destination);
  }

  function mute(on){
    muted = !!on;
    if(!bus||!lastCtx||lastCtx.state==='closed') return;
    try{
      bus.gain.cancelScheduledValues(lastCtx.currentTime);
      bus.gain.setValueAtTime(muted ? 0 : 0.45,lastCtx.currentTime);
    }catch(e){ bus.gain.value=muted ? 0 : 0.45; }
  }

  function rnd(a, b){ return a + Math.random() * (b - a); }

  // One bird syllable. o = {
  //   t: onset (absolute ctx time), f: [[dt, hz], ...] glide path,
  //   g: peak gain 0.05-0.12, a: attack, h: hold seconds (sustain shoulder),
  //   type: osc type, q: bandpass Q, vib: [rateHz, depthCents],
  //   breath: 0..1 air under the note, spark: octave-shimmer amount,
  //   j: timing-jitter scale }
  function syl(ctx, o){
    ensure(ctx);
    var det = Math.pow(2, rnd(-8, 8) / 1200);            // +-8 cents, never twice the same
    var js = (o.j === undefined) ? 1 : o.j;
    var t0 = Math.max(ctx.currentTime + 0.003, o.t + rnd(-0.012, 0.012) * js);
    var pts = o.f;
    var end = t0 + pts[pts.length - 1][0];
    var atk = Math.max(0.008, o.a || 0.012);
    var osc = ctx.createOscillator();
    osc.type = o.type || 'triangle';
    var osc2 = ctx.createOscillator();                    // octave sparkle
    osc2.type = 'sine';
    var g2 = ctx.createGain();
    g2.gain.value = ((o.spark === undefined) ? 1 : o.spark) * 0.2;
    var bp = ctx.createBiquadFilter();                    // beak: bandpass rides the glide
    bp.type = 'bandpass';
    bp.Q.value = o.q || 1.4;
    var env = ctx.createGain();
    osc.frequency.setValueAtTime(pts[0][1] * det, t0);
    osc2.frequency.setValueAtTime(pts[0][1] * det * 2, t0);
    bp.frequency.setValueAtTime(pts[0][1] * det, t0);
    var i, ft, fv;
    for(i = 1; i < pts.length; i++){
      ft = t0 + pts[i][0];
      fv = pts[i][1] * det;
      osc.frequency.exponentialRampToValueAtTime(fv, ft);
      osc2.frequency.exponentialRampToValueAtTime(fv * 2, ft);
      bp.frequency.exponentialRampToValueAtTime(fv, ft);
    }
    env.gain.setValueAtTime(0.0001, t0);
    env.gain.linearRampToValueAtTime(o.g, t0 + atk);
    if(o.h && o.h > atk + 0.01 && (t0 + o.h) < (end - 0.02)){
      env.gain.exponentialRampToValueAtTime(o.g * 0.5, t0 + o.h);
    }
    env.gain.exponentialRampToValueAtTime(0.001, end);
    env.gain.linearRampToValueAtTime(0, end + 0.012);
    if(o.vib){
      var lfo = ctx.createOscillator();
      lfo.type = 'sine';
      lfo.frequency.value = o.vib[0] * rnd(0.92, 1.08);
      var lg = ctx.createGain();
      lg.gain.setValueAtTime(0.001, t0);
      lg.gain.linearRampToValueAtTime(o.vib[1], t0 + Math.min(0.12, (end - t0) * 0.4));
      lfo.connect(lg);
      lg.connect(osc.detune);
      lg.connect(osc2.detune);
      lfo.start(t0);
      lfo.stop(end + 0.03);
    }
    osc.connect(bp);
    osc2.connect(g2);
    g2.connect(bp);
    bp.connect(env);
    env.connect(bus);
    osc.start(t0);
    osc2.start(t0);
    osc.stop(end + 0.03);
    osc2.stop(end + 0.03);
    if(o.breath){
      var nz = ctx.createBufferSource();
      nz.buffer = noiseBuf;
      nz.loop = true;
      var nbp = ctx.createBiquadFilter();
      nbp.type = 'bandpass';
      nbp.Q.value = 1.1;
      nbp.frequency.setValueAtTime(pts[0][1] * det * 1.4, t0);
      for(i = 1; i < pts.length; i++){
        nbp.frequency.exponentialRampToValueAtTime(pts[i][1] * det * 1.4, t0 + pts[i][0]);
      }
      var nenv = ctx.createGain();
      nenv.gain.setValueAtTime(0.0001, t0);
      nenv.gain.linearRampToValueAtTime(o.g * o.breath * 0.18, t0 + atk + 0.004);
      nenv.gain.exponentialRampToValueAtTime(0.0004, end);
      nenv.gain.linearRampToValueAtTime(0, end + 0.01);
      nz.connect(nbp);
      nbp.connect(nenv);
      nenv.connect(bus);
      nz.start(t0, rnd(0, 0.6));
      nz.stop(end + 0.02);
    }
    return end;
  }

  // A fast bulbul trill: n tiny alternating glides at 'rate' Hz.
  // Each micro-syllable glides to its target and settles there, so
  // consecutive syllables meet at the same frequency; the old version
  // returned downward inside the overlap window, which produced an
  // octave-down pitch-tracker artifact at trill transitions.
  function trill(ctx, t, f0, f1, n, rate, g){
    var per = 1 / rate;
    for(var i = 0; i < n; i++){
      var a = (i % 2 === 0) ? f0 : f1;
      var b = (i % 2 === 0) ? f1 : f0;
      syl(ctx, {
        t: t + i * per, g: g, a: 0.008, j: 0.25,
        type: 'sine', q: 2, spark: 0.6,
        f: [[0, a], [per * 0.55, b], [per * 0.85, b * 0.99]]
      });
    }
    return t + n * per;
  }

  function chirp(){
    var ctx = getCtx(); if(!ctx){ return; }
    ensure(ctx);
    var t = ctx.currentTime + 0.02;
    syl(ctx, { t: t, g: 0.10, type: 'triangle', q: 1.7, a: 0.009, j: 0.5,
      f: [[0, 1520], [0.036, 2320], [0.07, 1930]] });
    syl(ctx, { t: t + 0.095, g: 0.11, type: 'triangle', q: 1.6, a: 0.009, j: 0.5, breath: 0.35,
      f: [[0, 1760], [0.038, 2620], [0.08, 2140]] });
  }

  function peep(){
    var ctx = getCtx(); if(!ctx){ return; }
    ensure(ctx);
    var t = ctx.currentTime + 0.02;
    syl(ctx, { t: t, g: 0.07, type: 'sine', q: 1.9, a: 0.01, j: 0.5, breath: 0.5,
      f: [[0, 1560], [0.05, 1170], [0.105, 1230]] });
  }

  function whoosh(){
    var ctx = getCtx(); if(!ctx){ return; }
    ensure(ctx);
    var t0 = ctx.currentTime + 0.02;
    var nz = ctx.createBufferSource();
    nz.buffer = noiseBuf;
    nz.loop = true;
    var bp = ctx.createBiquadFilter();
    bp.type = 'bandpass';
    bp.Q.setValueAtTime(0.9, t0);
    bp.Q.linearRampToValueAtTime(1.6, t0 + 0.24);
    bp.frequency.setValueAtTime(2400, t0);
    bp.frequency.exponentialRampToValueAtTime(750, t0 + 0.22);
    bp.frequency.exponentialRampToValueAtTime(950, t0 + 0.30);
    var env = ctx.createGain();
    env.gain.setValueAtTime(0.0001, t0);
    env.gain.linearRampToValueAtTime(0.16, t0 + 0.06);
    env.gain.exponentialRampToValueAtTime(0.001, t0 + 0.30);
    env.gain.linearRampToValueAtTime(0, t0 + 0.31);
    nz.connect(bp);
    bp.connect(env);
    env.connect(bus);
    nz.start(t0, rnd(0, 0.6));
    nz.stop(t0 + 0.32);
  }

  function excited(){
    var ctx = getCtx(); if(!ctx){ return; }
    ensure(ctx);
    var t = ctx.currentTime + 0.02;
    syl(ctx, { t: t, g: 0.10, type: 'triangle', q: 1.7, a: 0.009, j: 0.4,
      f: [[0, 1220], [0.055, 1740]] });
    syl(ctx, { t: t + 0.08, g: 0.10, type: 'triangle', q: 1.7, a: 0.009, j: 0.4,
      f: [[0, 1520], [0.055, 2140]] });
    syl(ctx, { t: t + 0.16, g: 0.10, type: 'triangle', q: 1.7, a: 0.009, j: 0.4,
      f: [[0, 1840], [0.06, 2520]] });
    trill(ctx, t + 0.245, 2350, 2650, 4, 15.5, 0.085);
    syl(ctx, { t: t + 0.515, g: 0.09, type: 'sine', q: 1.6, a: 0.01, j: 0.4, breath: 0.4,
      f: [[0, 2480], [0.033, 2880], [0.075, 2580]] });
  }

  var songs = [
    { name: 'Pettigrew Hello', dur: 0.78, short: true, play: function(){
        // the classic red-whiskered bulbul motto: kick - pet - ti - grew
        var ctx = getCtx(); if(!ctx){ return; }
        ensure(ctx);
        var t = ctx.currentTime + 0.03;
        syl(ctx, { t: t, g: 0.10, type: 'triangle', q: 1.7,
          f: [[0, 2080], [0.03, 2480], [0.06, 2280]] });
        syl(ctx, { t: t + 0.15, g: 0.11, type: 'triangle', q: 1.6,
          f: [[0, 1880], [0.085, 1340]] });
        syl(ctx, { t: t + 0.30, g: 0.10, type: 'triangle', q: 1.6,
          f: [[0, 1480], [0.075, 2240]] });
        syl(ctx, { t: t + 0.44, g: 0.11, type: 'sine', q: 1.5, vib: [6.5, 12], h: 0.12, breath: 0.6,
          f: [[0, 2060], [0.07, 1620], [0.30, 1720]] });
      } },
    { name: 'Bayati Bloom', dur: 1.52, short: false, maqam: true, play: function(){
        // the site's soul: Bayati tetrachord on D5, sung as an ornamented phrase
        var ctx = getCtx(); if(!ctx){ return; }
        ensure(ctx);
        var t = ctx.currentTime + 0.03;
        // sung UP AN OCTAVE (D6) in his chirp register, with the chirp's scooped
        // triangle timbre - a bird singing Bayati, not a flute
        var D = 1174.6, Eq = 1281.0, F = 1397.0, G = 1568.0;
        syl(ctx, { t: t, g: 0.10, type: 'triangle', q: 1.7, breath: 0.4,
          f: [[0, D * 0.88], [0.045, D], [0.11, D * 1.005]] });
        syl(ctx, { t: t + 0.16, g: 0.10, type: 'triangle', q: 1.7,
          f: [[0, D * 0.94], [0.05, Eq], [0.10, Eq * 1.004]] });
        syl(ctx, { t: t + 0.31, g: 0.11, type: 'triangle', q: 1.6, vib: [6.5, 10], h: 0.07, breath: 0.4,
          f: [[0, Eq * 0.93], [0.05, F], [0.20, F * 0.997]] });
        syl(ctx, { t: t + 0.58, g: 0.095, type: 'triangle', q: 1.7,
          f: [[0, F * 0.95], [0.04, G], [0.085, G * 0.985]] });
        syl(ctx, { t: t + 0.71, g: 0.10, type: 'triangle', q: 1.7,
          f: [[0, G * 1.01], [0.05, F], [0.12, F * 0.996]] });
        syl(ctx, { t: t + 0.88, g: 0.095, type: 'triangle', q: 1.7,
          f: [[0, F * 1.005], [0.05, Eq], [0.11, Eq * 0.995]] });
        syl(ctx, { t: t + 1.06, g: 0.11, type: 'sine', q: 1.6, vib: [6, 13], h: 0.12, breath: 0.55,
          f: [[0, Eq], [0.06, D], [0.32, D * 0.99], [0.42, D * 0.97]] });
      } },
    { name: 'Saba Dusk', dur: 1.48, short: false, maqam: true, play: function(){
        // maqam Saba on D5: D, E-half-flat, F, G-FLAT - the tender, wistful mode.
        // rises gently, touches the aching G-flat once, and sighs back home
        var ctx = getCtx(); if(!ctx){ return; }
        ensure(ctx);
        var t = ctx.currentTime + 0.03;
        // chirp-register Saba (D6): scooped triangle syllables, the aching
        // G-flat touched once like a high sad chirp, then home
        var D = 1174.6, Eq = 1281.0, F = 1397.0, Gb = 1480.0;
        syl(ctx, { t: t, g: 0.10, type: 'triangle', q: 1.7, breath: 0.45,
          f: [[0, D * 0.89], [0.045, D], [0.12, D * 1.004]] });
        syl(ctx, { t: t + 0.17, g: 0.10, type: 'triangle', q: 1.7,
          f: [[0, D * 0.95], [0.05, Eq], [0.10, Eq * 1.003]] });
        syl(ctx, { t: t + 0.33, g: 0.105, type: 'triangle', q: 1.6, vib: [6, 9], h: 0.06,
          f: [[0, Eq * 0.94], [0.05, F], [0.16, F * 1.002]] });
        syl(ctx, { t: t + 0.56, g: 0.11, type: 'triangle', q: 1.6, vib: [5.5, 12], h: 0.11, breath: 0.55,
          f: [[0, F * 0.96], [0.05, Gb], [0.24, Gb * 0.995]] });
        syl(ctx, { t: t + 0.86, g: 0.095, type: 'triangle', q: 1.7,
          f: [[0, Gb * 0.99], [0.045, F], [0.10, F * 0.996]] });
        syl(ctx, { t: t + 1.02, g: 0.095, type: 'triangle', q: 1.7,
          f: [[0, F * 1.005], [0.045, Eq], [0.10, Eq * 0.995]] });
        syl(ctx, { t: t + 1.17, g: 0.105, type: 'sine', q: 1.6, vib: [5.5, 11], h: 0.12, breath: 0.6,
          f: [[0, Eq], [0.06, D], [0.26, D * 0.988]] });
      } },
    { name: 'Hijaz Dawn', dur: 1.42, short: false, maqam: true, play: function(){
        // maqam Hijaz on D5: D, E-FLAT, F-SHARP, G - the soaring mode.
        // leans on the flat second, takes the famous augmented leap, and
        // crowns the G with a held, shining vibrato
        var ctx = getCtx(); if(!ctx){ return; }
        ensure(ctx);
        var t = ctx.currentTime + 0.03;
        // chirp-register Hijaz (D6): the augmented leap becomes a real bird
        // swoop, and the crowned G a bright trilled top note
        var D = 1174.6, Eb = 1244.5, Fs = 1480.0, G = 1568.0;
        syl(ctx, { t: t, g: 0.10, type: 'triangle', q: 1.7, breath: 0.4,
          f: [[0, D * 0.89], [0.045, D], [0.10, D * 1.004]] });
        syl(ctx, { t: t + 0.15, g: 0.105, type: 'triangle', q: 1.7, vib: [6, 8], h: 0.05,
          f: [[0, D * 0.97], [0.05, Eb], [0.15, Eb * 0.998]] });
        syl(ctx, { t: t + 0.40, g: 0.11, type: 'triangle', q: 1.6,
          f: [[0, Eb * 0.95], [0.07, Fs], [0.12, Fs * 1.005]] });
        syl(ctx, { t: t + 0.58, g: 0.115, type: 'triangle', q: 1.6, vib: [6.5, 14], h: 0.17, breath: 0.55,
          f: [[0, Fs * 0.97], [0.05, G], [0.30, G * 1.003]] });
        syl(ctx, { t: t + 0.98, g: 0.085, type: 'triangle', q: 1.7, a: 0.01, j: 0.5,
          f: [[0, G], [0.035, Fs], [0.075, Fs * 0.997]] });
        syl(ctx, { t: t + 1.12, g: 0.10, type: 'sine', q: 1.6, vib: [6, 11], h: 0.10, breath: 0.5,
          f: [[0, Fs], [0.05, G], [0.20, G * 0.992]] });
      } },
    { name: 'Qafla Peep', dur: 0.82, short: true, maqam: true, play: function(){
        // a tiny Bayati cadence (qafla): F down through the half-flat to a
        // contented rest on D - his quickest maqam thought
        var ctx = getCtx(); if(!ctx){ return; }
        ensure(ctx);
        var t = ctx.currentTime + 0.028;
        // chirp-register qafla (D6): three quick scooped chirps falling home
        var D = 1174.6, Eq = 1281.0, F = 1397.0;
        syl(ctx, { t: t, g: 0.10, type: 'triangle', q: 1.7,
          f: [[0, F * 0.90], [0.05, F], [0.10, F * 1.003]] });
        syl(ctx, { t: t + 0.16, g: 0.10, type: 'triangle', q: 1.7,
          f: [[0, F * 1.005], [0.05, Eq], [0.10, Eq * 0.996]] });
        syl(ctx, { t: t + 0.33, g: 0.11, type: 'sine', q: 1.6, vib: [6, 11], h: 0.12, breath: 0.5,
          f: [[0, Eq], [0.055, D], [0.26, D * 0.986]] });
      } },
    { name: 'Morning Sips', dur: 0.79, short: true, play: function(){
        // three quick upward sips and a satisfied settle
        var ctx = getCtx(); if(!ctx){ return; }
        ensure(ctx);
        var t = ctx.currentTime + 0.028;
        syl(ctx, { t: t, g: 0.10, type: 'triangle', q: 1.6,
          f: [[0, 720], [0.085, 1060]] });
        syl(ctx, { t: t + 0.15, g: 0.10, type: 'triangle', q: 1.6,
          f: [[0, 820], [0.085, 1230]] });
        syl(ctx, { t: t + 0.30, g: 0.10, type: 'triangle', q: 1.6,
          f: [[0, 900], [0.08, 1350]] });
        syl(ctx, { t: t + 0.46, g: 0.11, type: 'sine', q: 1.5, vib: [6.5, 10], h: 0.1, breath: 0.4,
          f: [[0, 1000], [0.05, 1480], [0.11, 1430], [0.26, 1380]] });
      } },
    { name: 'Berry Trill', dur: 0.89, short: true, play: function(){
        // toot means berry: a bright little roll and a soft landing
        var ctx = getCtx(); if(!ctx){ return; }
        ensure(ctx);
        var t = ctx.currentTime + 0.028;
        syl(ctx, { t: t, g: 0.10, type: 'triangle', q: 1.6,
          f: [[0, 1120], [0.07, 1640], [0.10, 1560]] });
        var e = trill(ctx, t + 0.14, 1760, 2060, 6, 14.5, 0.08);
        syl(ctx, { t: e + 0.02, g: 0.11, type: 'sine', q: 1.5, vib: [6, 10], h: 0.1, breath: 0.5,
          f: [[0, 1980], [0.07, 1470], [0.22, 1530]] });
      } },
    { name: 'Dewdrop Waltz', dur: 1.55, short: false, play: function(){
        // grafted from the Music-Box Bulbul and re-sung in the velvet
        // voice: a lilting long-short-short waltz, each note scooping
        // up into pitch and settling, closing on a warm F
        var ctx = getCtx(); if(!ctx){ return; }
        ensure(ctx);
        var t = ctx.currentTime + 0.03;
        syl(ctx, { t: t, g: 0.10, type: 'triangle', q: 1.6, j: 0.5, vib: [6, 10], h: 0.09, breath: 0.3,
          f: [[0, 1275], [0.035, 1320], [0.24, 1308]] });
        syl(ctx, { t: t + 0.30, g: 0.08, type: 'triangle', q: 1.7, a: 0.01, j: 0.5,
          f: [[0, 1515], [0.03, 1569], [0.14, 1557]] });
        syl(ctx, { t: t + 0.46, g: 0.075, type: 'triangle', q: 1.7, a: 0.01, j: 0.5,
          f: [[0, 1283], [0.03, 1320], [0.13, 1311]] });
        syl(ctx, { t: t + 0.62, g: 0.095, type: 'triangle', q: 1.6, j: 0.5, vib: [5.7, 10], h: 0.08, breath: 0.3,
          f: [[0, 1137], [0.035, 1176], [0.22, 1167]] });
        syl(ctx, { t: t + 0.92, g: 0.075, type: 'triangle', q: 1.7, a: 0.01, j: 0.5,
          f: [[0, 1283], [0.03, 1320], [0.13, 1311]] });
        syl(ctx, { t: t + 1.06, g: 0.07, type: 'triangle', q: 1.7, a: 0.01, j: 0.5,
          f: [[0, 1140], [0.03, 1176], [0.13, 1167]] });
        syl(ctx, { t: t + 1.20, g: 0.10, type: 'sine', q: 1.5, j: 0.5, vib: [5.5, 12], h: 0.12, breath: 0.5,
          f: [[0, 1014], [0.05, 1047.7], [0.24, 1040], [0.36, 1029]] });
      } },
    { name: 'Sun Through Canopy', dur: 1.38, short: false, play: function(){
        // grafted from Glade and re-sung in the velvet voice: a long
        // low warm note, a breath, two grace-steps up, then a bright
        // held arc into light
        var ctx = getCtx(); if(!ctx){ return; }
        ensure(ctx);
        var t = ctx.currentTime + 0.03;
        syl(ctx, { t: t, g: 0.10, type: 'triangle', q: 1.5, vib: [5.5, 9], h: 0.14, breath: 0.6,
          f: [[0, 1162], [0.16, 1267], [0.30, 1235]] });
        syl(ctx, { t: t + 0.58, g: 0.07, type: 'triangle', q: 1.8, a: 0.009, j: 0.5,
          f: [[0, 1464], [0.04, 1645], [0.07, 1610]] });
        syl(ctx, { t: t + 0.68, g: 0.075, type: 'triangle', q: 1.8, a: 0.009, j: 0.5,
          f: [[0, 1645], [0.04, 1845], [0.07, 1806]] });
        syl(ctx, { t: t + 0.80, g: 0.11, type: 'sine', q: 1.5, vib: [6, 14], h: 0.20, breath: 0.6,
          f: [[0, 1845], [0.16, 2240], [0.44, 2114], [0.56, 2072]] });
      } }
  ];

  /* ── the four score songs ───────────────────────────────────────────────
     Sung in his chirp register (1174-2349Hz) in the same syl() idiom as the
     rest, so they are the same bird — just increasingly delighted. Pushed
     rather than written into the literal above so they cannot be swept into
     the random idle pool: these are only ever played by name.
     They climb the same Bayati that the academy teaches, which is why the top
     of Jubilee feels like an arrival rather than just a high note. */
  songs.push(
    { name: 'Score Gentle', dur: 0.70, short: false, scoreOnly: true, tier: 0, play: function(){
        // 0-6.9: gentle reassurance, deliberately smaller than a fanfare.
        var ctx = getCtx(); if(!ctx){ return; }
        ensure(ctx);
        var t = ctx.currentTime + 0.03;
        var D = 1174.6, Eq = 1281.0;
        syl(ctx, { t: t, g: 0.075, type: 'triangle', q: 1.8, breath: 0.5,
          f: [[0, D * 0.92], [0.05, D], [0.18, D * 0.998]] });
        syl(ctx, { t: t + 0.27, g: 0.08, type: 'sine', q: 1.7, vib: [5.5, 8], h: 0.08, breath: 0.6,
          f: [[0, Eq], [0.08, D], [0.30, D * 0.992]] });
      } },
    { name: 'Score Good', dur: 0.90, short: true, scoreOnly: true, tier: 1, play: function(){
        // 7-7.9: warm and encouraging. Three notes that rise and settle — a
        // nod, not a fanfare. Anything triumphant here would read as sarcasm.
        var ctx = getCtx(); if(!ctx){ return; }
        ensure(ctx);
        var t = ctx.currentTime + 0.03;
        var D = 1174.6, Eq = 1281.0, F = 1397.0;
        syl(ctx, { t: t, g: 0.095, type: 'triangle', q: 1.7, breath: 0.4,
          f: [[0, D * 0.90], [0.05, D], [0.12, D * 1.004]] });
        syl(ctx, { t: t + 0.20, g: 0.10, type: 'triangle', q: 1.7,
          f: [[0, D * 0.96], [0.05, F], [0.13, F * 0.998]] });
        syl(ctx, { t: t + 0.42, g: 0.10, type: 'sine', q: 1.6, vib: [6, 11], h: 0.14, breath: 0.55,
          f: [[0, F], [0.06, Eq], [0.34, Eq * 0.99]] });
      } },
    { name: 'Score Bright', dur: 1.30, short: false, scoreOnly: true, tier: 2, play: function(){
        // 8-8.9: a five-note run up the tetrachord with a lifted, held top.
        var ctx = getCtx(); if(!ctx){ return; }
        ensure(ctx);
        var t = ctx.currentTime + 0.03;
        var D = 1174.6, Eq = 1281.0, F = 1397.0, G = 1568.0, A = 1760.0;
        syl(ctx, { t: t, g: 0.10, type: 'triangle', q: 1.7, breath: 0.35,
          f: [[0, D * 0.90], [0.04, D], [0.09, D * 1.005]] });
        syl(ctx, { t: t + 0.14, g: 0.10, type: 'triangle', q: 1.7,
          f: [[0, D * 0.95], [0.04, Eq], [0.085, Eq * 1.004]] });
        syl(ctx, { t: t + 0.28, g: 0.105, type: 'triangle', q: 1.65,
          f: [[0, Eq * 0.95], [0.04, F], [0.085, F * 1.003]] });
        syl(ctx, { t: t + 0.42, g: 0.105, type: 'triangle', q: 1.65,
          f: [[0, F * 0.95], [0.04, G], [0.09, G * 1.002]] });
        syl(ctx, { t: t + 0.58, g: 0.11, type: 'triangle', q: 1.6, vib: [7, 12], h: 0.10,
          f: [[0, G * 0.95], [0.05, A], [0.26, A * 0.998]] });
        syl(ctx, { t: t + 0.92, g: 0.10, type: 'sine', q: 1.6, vib: [6.5, 13], h: 0.14, breath: 0.5,
          f: [[0, A], [0.06, G], [0.30, G * 0.99]] });
      } },
    { name: 'Score Jubilee', dur: 2.00, short: false, scoreOnly: true, tier: 3, play: function(){
        // 9-10: he bolts up the maqam, trills on the top, holds it with a wide
        // vibrato, then comes home. The only place he ever sings this high.
        var ctx = getCtx(); if(!ctx){ return; }
        ensure(ctx);
        var t = ctx.currentTime + 0.03;
        var D = 1174.6, F = 1397.0, G = 1568.0, A = 1760.0, C = 2093.0, D7 = 2349.3;
        syl(ctx, { t: t, g: 0.10, type: 'triangle', q: 1.75,
          f: [[0, D * 0.90], [0.035, D], [0.07, D * 1.006]] });
        syl(ctx, { t: t + 0.10, g: 0.10, type: 'triangle', q: 1.75,
          f: [[0, D], [0.035, F], [0.07, F * 1.005]] });
        syl(ctx, { t: t + 0.20, g: 0.105, type: 'triangle', q: 1.7,
          f: [[0, F], [0.035, G], [0.07, G * 1.005]] });
        syl(ctx, { t: t + 0.30, g: 0.105, type: 'triangle', q: 1.7,
          f: [[0, G], [0.035, A], [0.075, A * 1.004]] });
        syl(ctx, { t: t + 0.41, g: 0.11, type: 'triangle', q: 1.65, vib: [8, 14], h: 0.12,
          f: [[0, A], [0.05, C], [0.22, C * 0.999]] });
        syl(ctx, { t: t + 0.70, g: 0.09, type: 'triangle', q: 1.8,
          f: [[0, C], [0.03, D7], [0.06, C]] });
        syl(ctx, { t: t + 0.79, g: 0.09, type: 'triangle', q: 1.8,
          f: [[0, C], [0.03, D7], [0.06, C]] });
        syl(ctx, { t: t + 0.88, g: 0.095, type: 'triangle', q: 1.75,
          f: [[0, C], [0.03, D7], [0.07, D7 * 1.003]] });
        syl(ctx, { t: t + 1.02, g: 0.115, type: 'sine', q: 1.6, vib: [7, 16], h: 0.26, breath: 0.5,
          f: [[0, D7 * 0.97], [0.05, D7], [0.42, D7 * 0.995]] });
        syl(ctx, { t: t + 1.50, g: 0.10, type: 'sine', q: 1.6, vib: [6, 13], h: 0.16, breath: 0.55,
          f: [[0, C], [0.07, A], [0.36, A * 0.99]] });
      } }
  );

  return { chirp: chirp, peep: peep, whoosh: whoosh, excited: excited, songs: songs, mute: mute };
}


/* ================= THEME GLUE (saifsite) ================= */
(function(){
  var cfgEl=document.getElementById('saif-toot-config');
  var cfg=cfgEl?JSON.parse(cfgEl.textContent):{};
  var rtl=(document.documentElement.dir==='rtl');
  var tpl=String(cfg.template||'');
  /* Both the dedicated page and the copy embedded in a lesson are the same
     Studio experience. Keep Toot host-driven in either context: branch at
     rest, explicit score seat while results are open, and the active tutorial
     card while he teaches. The lesson page simply waits to reveal him until
     its below-the-fold Studio actually enters the viewport. */
  var studioFocusedTemplate=(tpl==='page.practice-studio'||tpl==='page.saif-lesson');
  var lessonStudioTemplate=(tpl==='page.saif-lesson');

  /* He is the Practice Studio's teacher. If the studio is not on this page he
     has nothing to teach, so he does not appear — this also catches any template
     the Liquid gate lets through (a renamed page, a section moved elsewhere). */
  if(!(document.getElementById('SaifPracticeStudio')||document.querySelector('.saif-practice'))){
    var _nl=document.getElementById('toot-layer'); if(_nl) _nl.remove();
    var _nt=document.getElementById('tipbubble'); if(_nt) _nt.remove();
    return;
  }

  /* hide preference: fully dormant when hidden */
  try{ if(localStorage.getItem('saif:toot:hidden')==='1'){ var L=document.getElementById('toot-layer'); if(L)L.remove(); var B=document.getElementById('callbtn'); if(B)B.remove(); return; } }catch(e){}

  /* park off-screen NOW — never a frame at the wrap's default (0,0) top-left */
  /* Keep the Studio mascot invisible until his real branch has been measured
     and seated. This closes the refresh race where the off-screen/default pose
     could paint for a frame before entrance() or the seat watchdog won. */
  var initLayer=document.getElementById('toot-layer');
  if(studioFocusedTemplate&&initLayer){
    initLayer.setAttribute('data-toot-init-pending','1');
    initLayer.style.opacity='0';
  }
  var startupSeatRAF=0,startupSeatUntil=0;
  function lockStudioSeat(ms){
    if(!studioFocusedTemplate) return;
    startupSeatUntil=Math.max(startupSeatUntil,performance.now()+(ms||700));
    if(startupSeatRAF) return;
    function lockFrame(){
      startupSeatRAF=0;
      if(state==='perch'&&perchedOn&&perchedOn.isConnected) rideNow();
      if(performance.now()<startupSeatUntil) startupSeatRAF=requestAnimationFrame(lockFrame);
    }
    lockFrame();
  }
  var studioEntranceArmed=false;
  function revealStudioBird(el,reduce){
    if(!initLayer||!initLayer.hasAttribute('data-toot-init-pending')||!el) return;
    function showLayer(){
      /* The markup starts hidden only to prevent one folded-wing paint before
         JS is ready. Reveal at full opacity once the off-screen flight pose is
         installed; the entrance itself supplies the motion, not a fade. */
      initLayer.removeAttribute('data-toot-init-pending');
      initLayer.style.transition='none';
      initLayer.style.opacity='1';
    }
    if(reduce){
      takeSeat(el,false);
      showLayer();
      lockStudioSeat(900);
      return;
    }

    /* The Studio focuses and sizes its controls just after startup, which can
       adjust page scroll. Let that settle before building a target-tracking
       path so the whole entrance cannot be pulled upward mid-flight. */
    if(!studioEntranceArmed){
      studioEntranceArmed=true;
      setTimeout(function(){
        var target=studioBranch()||el;
        /* The lesson Studio can leave the viewport during this short settle
           delay. Re-arm its visibility watcher instead of flying Toot toward
           a branch the student can no longer see. */
        if(lessonStudioTemplate&&!seatUsable(target)){
          studioEntranceArmed=false;
          entrance();
          return;
        }
        revealStudioBird(target,false);
      },320);
      return;
    }

    var r=el.getBoundingClientRect();
    var landingTop=r.top+r.height*0.5-BW*0.94;
    perchedOn=null; freeAnchor=null; state='fly'; FR=0; FSX=FSY=1;
    pos={
      x:innerWidth+Math.max(28,BW*0.7),
      y:Math.max(110,Math.min(innerHeight-BW-24,landingTop-Math.min(70,BW*0.7)))
    };
    toot.classList.remove('idle','land','flaring','fx-hop');
    toot.classList.add('flying');
    setRigTransition('none');
    apply();
    showLayer();

    /* Keep the airborne SVG (extended, animated wings) active from the first
       visible edge frame until flyLeg completes its exact branch landing. */
    requestAnimationFrame(function(){
      if(micLive){ takeSeat(el,false); lockStudioSeat(900); return; }
      var leg=flyLeg({el:el},{style:'sweep',land:true,v:460,quiet:true});
      if(leg&&leg.then) leg.then(function(result){
        if(!result||!result.cancelled) lockStudioSeat(900);
      });
    });
  }

  /* Mark the flight pose before apply() so even a forced early paint cannot
     show folded perch wings on an airborne bird. */
  state='fly'; toot.classList.remove('idle'); toot.classList.add('flying');
  pos={x:innerWidth+BW*2,y:-BW*2}; FR=0; apply();
  setSize(innerWidth<=820?64:88); /* art-directed scale: companion, not UI blocker */

  /* Call Toot is gone (owner). callToot() itself stays — window.SaifToot.call
     still uses it, and the tour uses the same flight code underneath. */

  /* -------- per-template perch map (from the sitewide plan) -------- */
  var MAP={"404":[{"s":".saif-404__number","rx":0.5,"ry":0.22,"pri":2.4,"sing":true}],"index":[{"s":".saif-ps__visual","rx":0.5,"pri":2.5,"sing":true},{"s":".saif-pricing__card--featured","rx":0.12,"pri":3,"sing":false},{"s":".saif-guarantee__inner","rx":0.9,"pri":1.5,"sing":false},{"s":".saif-final-cta__inner","rx":0.88,"pri":3,"sing":true}],"collection.saif-courses":[{"s":".saif-course-card","rx":0.17,"pri":2},{"s":".saif-courses__paths","rx":0.82,"pri":1}],"product.saif-course":[{"s":".saif-course__path-node--current","rx":0.1,"pri":4},{"s":".saif-course__lessons","rx":0.775,"pri":3},{"s":".saif-course__inside-card","rx":0.15,"pri":5,"sing":true},{"s":".saif-course__guarantee","rx":0.92,"pri":6}],"page.practice-studio":[{"s":".saif-practice","rx":0.05,"pri":3},{"s":".saif-pricing__card--featured","rx":0.88,"pri":2.5,"sing":true}],"page.saif-booking":[{"s":".saif-booking__next-btn","rx":0.82,"pri":2.7,"sing":true},{"s":".saif-booking__slots","rx":0.97,"pri":2}],"cart":[{"s":".saif-cart-empty__card:first-of-type","rx":0.08,"pri":2.1,"sing":true},{"s":".saif-cart-trust__bump","rx":0.92,"pri":2.7,"sing":true}],"page.saif-my-courses":[{"s":".saif-my-courses__empty-card","rx":0.9,"pri":2.7,"sing":true},{"s":".saif-course-card","rx":0.9,"pri":2.1,"sing":true},{"s":"#SaifFeedbackInbox","rx":0.93,"pri":2.4,"sing":true},{"s":"#SaifStreakTracker","rx":0.9,"pri":1.5,"sing":true}],"article":[{"s":".article-template__hero-container","rx":0.9,"pri":1.5,"sing":true},{"s":".article-template__comment-wrapper","rx":0.92,"pri":4,"sing":false},{"s":".article-template__back","rx":0.8,"pri":3,"sing":false}],"product.practice-studio-monthly":[{"s":".saif-sub__pricecard","rx":0.9,"pri":3,"sing":true},{"s":".saif-sub__aside","rx":0.85,"pri":1.5,"sing":false},{"s":".saif-sub__desc","rx":0.9,"pri":1,"sing":false}],"product.practice-studio-annual":[{"s":".saif-sub__pricecard","rx":0.9,"pri":3,"sing":true},{"s":".saif-sub__aside","rx":0.85,"pri":1.5,"sing":false},{"s":".saif-sub__desc","rx":0.9,"pri":1,"sing":false}],"saif-subscription-product.liquid":[{"s":".saif-sub__pricecard","rx":0.9,"pri":3,"sing":true},{"s":".saif-sub__aside","rx":0.85,"pri":1.5,"sing":false},{"s":".saif-sub__desc","rx":0.9,"pri":1,"sing":false}],"blog":[{"s":".article-template__hero-container","rx":0.9,"pri":1.5,"sing":true},{"s":".article-template__comment-wrapper","rx":0.92,"pri":4,"sing":false},{"s":".article-template__back","rx":0.8,"pri":3,"sing":false}]};
  /* The site-wide footer perch is gone with the site-wide bird: on a studio page
     it only ever lured him away from the thing he is here to teach. Same reason
     the studio template's pricing-card perch is dropped below. */
  var GLOBAL=[];
  /* The dedicated Studio is host-driven. Its only legal seats are enforced
     below: the branch, the result marker, and the active tutorial card. */
  MAP['page.practice-studio']=[];
  MAP['page.saif-lesson']=[];
  function applyPerches(){
    var defs=(MAP[tpl]||[]).concat(GLOBAL);
    var mobile=innerWidth<=820;
    defs.forEach(function(d){
      document.querySelectorAll(d.s).forEach(function(el){
        if(mobile&&/(^|\s|__)card/.test(el.className)) return;  /* stacked cards sit under copy on mobile */
        el.dataset.perch=''; el.dataset.perchRx=String(rtl?(1-d.rx):d.rx); el.dataset.perchPri=String(d.pri);
        if(d.ry) el.dataset.perchRy=String(d.ry);
        if(d.sing) el.dataset.sing='';
        el.addEventListener('click',function(){ if(!busy&&!micLive&&state==='perch') flyTo(el); });
      });
    });
  }
  applyPerches();

  /* tips: English only for now — suppress on other locales */
  if(cfg.locale&&cfg.locale!=='en'){ window.__TOOT_TIPS.length=0; }

  /* -------- frequency caps: tip ledger (max 2 unsolicited/session, 5/day, 90s gap) -------- */
  var _origShowTip=showTip, sessTips=0, lastTip=0;
  showTip=function(text){
    var n=Date.now();
    if(!text){ /* unsolicited */
      try{ var led=JSON.parse(localStorage.getItem('saif:toot:ledger')||'{}');
        var today=new Date().toDateString();
        if(led.day!==today){ led.day=today; led.count=0; }
        if(sessTips>=2||led.count>=5||n-lastTip<90000) return false;
        if(_origShowTip(text)){ sessTips++; lastTip=n; led.count=(led.count||0)+1;
          localStorage.setItem('saif:toot:ledger',JSON.stringify(led)); return true; }
        return false;
      }catch(e){ return _origShowTip(text); }
    }
    return _origShowTip(text);
  };

  /* -------- Practice Studio hard interlock (poll + stop-button observer; no studio edits) -------- */
  function micPredicate(){ try{ var st=window.SaifPracticeStudio; if(!st) return false;
    if(st.state==='starting'||st.state==='recording') return true;
    if(st.tunerStream||st.drillStream||st.rangeStream) return true; }catch(e){} return false; }
  function setHush(on){ if(on!==micLive) toggleMic(); }
  if(document.getElementById('SaifPracticeStudio')||document.querySelector('.saif-practice')){
    setInterval(function(){ setHush(micPredicate()); },250);
    var stopBtn=document.getElementById('SaifPracticeStopBtn');
    if(stopBtn&&window.MutationObserver){ new MutationObserver(function(){ setHush(!stopBtn.hidden||micPredicate()); })
      .observe(stopBtn,{attributes:true,attributeFilter:['hidden']}); }
  }

  /* ================= WHERE HE SITS IN THE STUDIO =================
     The dedicated Practice Studio has one and only one resting seat: his tree
     branch. Score and tutorial seats are explicit, transient host requests.
     Keep the older ordered list only for an embedded studio on another template. */
  var SEATS = [
    '#SaifPracticeTourTeaser .saif-practice__tour-teaser-card',
    '#SaifPracticeNowbar',
    '.saif-practice__refbar',
    '.saif-practice__canvas-wrap',
    '.saif-practice__controls',
    '.saif-practice'
  ];
  function headRoom(){ return 96 + BW * 0.94 + 6; }   /* sticky header + his body */
  function footRoom(){
    var lo = innerHeight - 40;
    var ban = document.getElementById('shopify-pc__banner');
    if (ban && ban.offsetParent) { var br = ban.getBoundingClientRect();
      if (br.top > innerHeight * 0.35) lo = Math.min(lo, br.top - 20); }
    return lo;
  }
  function seatUsable(el){
    if (!el || !el.isConnected) return false;
    var st = getComputedStyle(el);
    if (st.display === 'none' || st.visibility === 'hidden') return false;
    var r = el.getBoundingClientRect();
    if (r.width < 40 || r.height < 8) return false;
    var feet = r.top + r.height * (+(el.dataset.perchRy || 0));
    return feet > headRoom() && feet < footRoom();
  }
  /* On a first visit the cookie banner can eat the bottom half of a phone while
     the sticky header eats the top, leaving NO element whose edge is inside the
     safe band. Rather than leave him hanging off screen, pin him to a page point
     that is inside it — he is still a bird sitting still, just not on anything. */
  function pinSafe(){
    var HI=headRoom(), LO=footRoom();
    if(LO<=HI) return false;
    var feet=Math.max(HI,Math.min(LO,HI+(LO-HI)*0.35));
    perchedOn=null;
    freeAnchor={ px:Math.max(10,Math.min(innerWidth-BW-10,innerWidth*0.10))+scrollX,
                 py:(feet-BW*0.94)+scrollY };
    clearRigTransition(); resetRigPose(); state='perch'; toot.classList.add('idle'); rideNow();
    return true;
  }
  function studioBranch(){
    var el=document.querySelector('.saif-practice__toot-seat');
    if(!el||!el.isConnected) return null;
    var st=getComputedStyle(el), r=el.getBoundingClientRect();
    if(st.display==='none'||st.visibility==='hidden'||r.width<=0||r.height<=0) return null;
    /* Use the same center anchor as PracticeStudio._tootSeat('home') from the
       first frame. The generic perch defaults (18% / top edge) caused a brief
       12-16px startup offset before the Studio controller corrected them. */
    el.dataset.perchRx='0.5';
    el.dataset.perchRy='0.5';
    return el;
  }
  function studioAllowedSeat(el){
    if(!studioFocusedTemplate) return true;
    return !!(el&&el.classList&&(
      el.classList.contains('saif-practice__toot-seat')||
      el.classList.contains('saif-practice__top-toot-seat')||
      el.classList.contains('saif-practice__result-toot-seat')||
      el.id==='SaifSheetTuner'||
      el.id==='SaifSheetDrill'||
      el.id==='SaifSheetRange'||
      el.id==='SaifSheetHistory'||
      el.classList.contains('saif-practice-tour__card')
    ));
  }
  function studioSeat(){
    if(studioFocusedTemplate) return studioBranch();
    for (var i = 0; i < SEATS.length; i++) {
      var el = document.querySelector(SEATS[i]);
      if (seatUsable(el)) return el;
    }
    return null;
  }
  function takeSeat(el, fly){
    if (!el) return false;
    el.dataset.perch = '';
    /* The teaser card is a dialog he is speaking through, so he sits on its
       ROOF: feet on the top edge (ry 0) and out at the shoulder, never over
       the sentence. Without this he could inherit a mid-face anchor and blank
       out his own words. */
    if (el.classList && el.classList.contains('saif-practice__tour-teaser-card')) {
      el.dataset.perchRx = String(rtl ? 0.16 : 0.84);
      el.dataset.perchRy = '0';
    }
    if (!el.dataset.perchRx) el.dataset.perchRx = String(rtl ? 0.82 : 0.18);
    if (fly && state === 'perch' && !busy) { try { flyTo(el, 'swoop', { quiet: true }); return true; } catch (e) {} }
    glueTo(el);
    return true;
  }
  /* If he ever ends up off screen — a resize, an orientation flip, a section
     collapsing under him — put him back. Silently: he is invisible at that
     moment, so there is no visible jump to worry about. */
  var seatHoldUntil = 0;
  function seatWatchdog(){
    if (teaching || busy || micLive || state !== 'perch' || document.hidden) return;
    if (performance.now() < seatHoldUntil) return;   /* a scripted move is under way */
    var screen=rigScreenPos();
    var offscreen = (screen.y < 0 || screen.y > innerHeight - BW * 0.5 || screen.x < -BW * 0.4 || screen.x > innerWidth - BW * 0.4);
    var seatGone = perchedOn ? !(perchedOn.isConnected && seatUsable(perchedOn)) : !freeAnchor;
    if (!offscreen && !seatGone) return;
    // only ever relocate him INSTANTLY while he is off screen; if he is visible
    // and merely badly seated, fly — an instant hop reads as a teleport.
    var el = studioSeat();
    if(studioFocusedTemplate){
      /* A hidden/off-screen branch is not a destination. While a sheet owns the
         stage, or whenever home cannot be seen, use the real Studio top-edge
         marker. Every visible relocation flies; no silent branch teleport. */
      var studio=document.querySelector('.saif-practice');
      var edge=document.querySelector('.saif-practice__top-toot-seat');
      var sheetOpen=!!(studio&&studio.classList.contains('saif-practice--sheet-open'));
      if(!sheetOpen&&el&&seatUsable(el)&&el!==perchedOn){ takeSeat(el,!offscreen); return; }
      if(edge&&seatUsable(edge)&&edge!==perchedOn){ takeSeat(edge,!offscreen); }
      return;
    }
    if (el && el !== perchedOn) { takeSeat(el, !offscreen); return; }
    if (!el && offscreen) pinSafe();
  }

  /* -------- homepage journey: he starts on the quiz and follows the reader down the page -------- */
  var jEls=[], followCheck=null;
  function HEADROOM(){ return 96+BW*0.94+8; }
  function pcBanner(){ var b=document.getElementById('shopify-pc__banner'); return (b&&b.offsetParent)?b.getBoundingClientRect():null; }
  /* where do his feet sit on this stop? Always a REAL edge: the element top, or its declared data-perch-ry ledge */
  function seatY(el){ var r=el.getBoundingClientRect(); return {ay:r.top+r.height*(+(el.dataset.perchRy||0)),el:el}; }
  function glueTo(el){ clearRigTransition(); resetRigPose(); perchedOn=el; freeAnchor=null; state='perch'; toot.classList.add('idle'); rideNow(); }
  if(tpl==='index'){
    /* ordered stops in TRUE section order: hero → before-after → outcomes → practice-studio →
       instructor → pricing → guarantee → faq → final-cta. [selector, rx, ry, pri, sing] */
    /* ART-DIRECTED journey (each seat iterated by eye on the live page — see sound-out/siteart.json):
       quiz answer-ledge RIGHT → before/after card LEFT → Advanced-Mastery card RIGHT → pitch-panel
       STAGE (center, sings) → instructor portrait frame LEFT → pricing gold rail RIGHT → FAQ reading
       seat → final-CTA HORIZON silhouette (feet on the cream/dark boundary) → footer wire (sings) */
    var JDESK=[['.saif-hero__quiz-card',0.93,0.265,2.5,true],
     ['.saif-ba__card',0.1,0,1.6,false],
     ['.saif-outcomes__card:nth-child(3)',0.85,0,1.4,false],
     ['.saif-ps__visual',0.55,0,2.5,true],
     ['.saif-instructor__img',0.3,0,1.8,false],
     ['.saif-pricing__card--featured',0.85,0,3,false],
     ['.saif-faq__list',0.96,0,1.2,false],
     ['.saif-final-cta',0.08,0,2,false],
     ['.footer__follow-on-shop',0.12,0,0.8,true]];
    var JMOB=[['.saif-hero__quiz-card',0.91,0.3,2.5,true],
     ['.saif-ps__visual',0.85,0,2.5,true],
     ['.saif-pricing__card--featured',0.85,0,3,false],
     ['.saif-final-cta',0.08,0,2,false],
     ['.footer__follow-on-shop',0.12,0,0.8,true]];
    (innerWidth<=820?JMOB:JDESK).forEach(function(a){ var el=document.querySelector(a[0]);
      if(!el){ try{console.warn('[toot] journey stop missing:',a[0]);}catch(e){} return; }
      el.dataset.perch=''; el.dataset.perchRx=String(rtl?(1-a[1]):a[1]);
      if(a[2]) el.dataset.perchRy=String(a[2]); else delete el.dataset.perchRy;
      el.dataset.perchPri=String(a[3]); if(a[4]) el.dataset.sing='';
      if(!el.dataset.tootClick){ el.dataset.tootClick='1';
        el.addEventListener('click',function(){ if(!busy&&!micLive&&state==='perch') flyTo(el); }); }
      jEls.push(el); });
    GLOBAL.forEach(function(g){ document.querySelectorAll(g.s).forEach(function(el){ if(jEls.indexOf(el)<0) jEls.push(el); }); });
    var _fT=null,_dir=1,_lastY=scrollY;
    followCheck=function(){
      if(window.__tootFreeze||window.__tootTeaching) return;
      if(micLive||busy||state!=='perch'||document.hidden) return;
      if(performance.now()<actUntil) return;                      /* let songs/emotes finish */
      var H=HEADROOM(), LOW=innerHeight*0.86;
      var ban=pcBanner(); if(ban) LOW=Math.min(LOW,ban.top-30);   /* never seat him behind the consent dialog */
      var cur=(perchedOn&&perchedOn.isConnected)?perchedOn:null;
      if(cur){ var cs=seatY(cur); if(cs.ay>H-60&&cs.ay<innerHeight-BW*0.25) return; } /* ride a seat further down the glass before departing */
      var best=null,bd=1e9;
      jEls.forEach(function(el){ if(!el.isConnected) return; var s=seatY(el);
        if(s.ay<H||s.ay>LOW) return;
        var d=Math.abs(s.ay-innerHeight*0.45); if(d<bd){bd=d;best=s;} });
      /* no stop on screen? He simply STAYS on his old seat — like a real bird you walk past. */
      if(!best||best.el===perchedOn) return;
      /* don't launch at a section still animating in (theme reveal transforms) */
      var rev=best.el.closest('.saif-reveal,[data-saif-motion]');
      if(rev&&getComputedStyle(rev).opacity<0.9){ clearTimeout(_fT); _fT=setTimeout(followCheck,300); return; }
      var tr2=best.el.getBoundingClientRect();
      var seatX=tr2.left+tr2.width*(+(best.el.dataset.perchRx||0.5))-BW/2;
      /* far-off origin: re-enter from a graceful SIDE offset, never a vertical drop down the same column */
      var far=false;
      if(pos.y<-BW*1.5){ far=true; pos.y=-BW*1.2; }
      else if(pos.y>innerHeight+BW*0.5){ far=true; pos.y=innerHeight+BW*0.3; }
      if(far){ pos.x=Math.max(-BW*0.4,Math.min(innerWidth-BW*0.6, seatX+((_hop%2)?-1:1)*innerWidth*0.28)); apply(); }
      var style=_dir>0?'swoop':'sweep';
      var after=function(){ clearTimeout(_fT); _fT=setTimeout(followCheck,1400+Math.random()*600); };
      var chord=Math.hypot(seatX-pos.x, seatY(best.el).ay-BW*0.94-pos.y);
      if(chord>innerHeight*0.8){ /* long catch-up: glide in, hover a beat to scan, then settle */
        var hx=Math.max(BW,Math.min(innerWidth-BW*1.5, seatX+((_hop%2)?-1:1)*120)), hy=Math.max(HEADROOM(), seatY(best.el).ay-140);
        flyLeg({x:hx,y:hy},{style:'sweep',endPose:'hover',v:480,quiet:true})
          .then(function(){ return hoverBob(450); })
          .then(function(){ return flyTo(best.el,style,{v:450,quiet:true}); }).then(after); }
      else flyTo(best.el,style,{v:450,quiet:true}).then(after); /* unhurried, quiet ambient hop */
    };
    /* On the Practice Studio he does NOT chase the scroll: the studio drives
       him from real state changes (see SaifToot.perchOn) and a scroll-follower
       on top of that is exactly the "jumps around for no reason" the owner
       reported. Every other template keeps the ambient follower. */
    if(!studioFocusedTemplate){
    addEventListener('scroll',function(){ var y=scrollY; if(y!==_lastY){ _dir=y>_lastY?1:-1; _lastY=y; }
      clearTimeout(_fT); _fT=setTimeout(followCheck,520+Math.random()*360); },{passive:true});
    if(window.IntersectionObserver){ var io=new IntersectionObserver(function(){ clearTimeout(_fT); _fT=setTimeout(followCheck,430+Math.random()*300); },{threshold:[0,0.4]});
      jEls.forEach(function(el){ io.observe(el); }); }
    }
  }

  /* hide him while the mobile menu drawer is open; lift the Call button above preview/consent bars */
  (function(){ var L=document.getElementById('toot-layer');
    setInterval(function(){ if(!L) return;
      var open=!!document.querySelector('details[open] .menu-drawer, .menu-drawer--is-open, header-drawer details[open]');
      L.style.visibility=open?'hidden':''; },700);   /* the Call button is gone; only the bird hides */
    })();

  /* -------- leaving the Studio: acknowledge, but never abandon the seat -------- */
  document.addEventListener('click',function(e){
    var a=e.target&&e.target.closest&&e.target.closest('a[href]'); if(!a) return;
    if(a.target==='_blank'||a.hasAttribute('download')||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button!==0) return;
    var u; try{ u=new URL(a.href,location.href); }catch(err){ return; }
    if(u.origin!==location.origin) return;
    var rawHref=a.getAttribute('href')||'';
    if(rawHref===''||rawHref.charAt(0)==='#') return;              /* JS-handled / anchor links never navigate */
    if(u.pathname===location.pathname&&(u.hash||u.href===location.href)) return;
    /* Acknowledge navigation without abandoning the current seat. The old
       continuity handoff launched him sideways and left stale transforms when
       the page came back from history. */
    try{ sessionStorage.removeItem('toot.h1'); }catch(err){}
    if(!micLive&&state==='perch'&&!busy){ try{ fxFlutterHop(true); }catch(err){} }
  },{capture:true,passive:true});

  /* Window focus changes never choose a new destination. Blur gets one small
     stationary flutter; focus/pageshow only re-snap the existing legal seat so
     a restored page cannot inherit an in-between transform. */
  var lastFocusFlap=0;
  addEventListener('blur',function(){
    var now=performance.now();
    if(!studioFocusedTemplate||micLive||busy||state!=='perch'||!perchedOn||now-lastFocusFlap<700) return;
    lastFocusFlap=now;
    try{ fxFlutterHop(true); }catch(e){}
  });
  function restoreFocusedSeat(){
    if(!studioFocusedTemplate||state!=='perch'||!perchedOn||!perchedOn.isConnected) return;
    clearRigTransition();
    resetRigPose();
    lockStudioSeat(900);
  }
  addEventListener('focus',restoreFocusedSeat);
  addEventListener('pageshow',restoreFocusedSeat);

  /* -------- entrance decision tree -------- */
  var _entTries=0;
  var lessonEntranceBound=false,lessonEntranceRAF=0,lessonEntranceIO=null;
  function armLessonStudioEntrance(){
    if(lessonEntranceBound||!lessonStudioTemplate) return;
    lessonEntranceBound=true;
    function cleanup(){
      if(!lessonEntranceBound) return;
      lessonEntranceBound=false;
      removeEventListener('scroll',queueLessonEntrance);
      removeEventListener('resize',queueLessonEntrance);
      if(lessonEntranceIO){ try{ lessonEntranceIO.disconnect(); }catch(e){} lessonEntranceIO=null; }
      if(lessonEntranceRAF){ cancelAnimationFrame(lessonEntranceRAF); lessonEntranceRAF=0; }
    }
    function checkLessonEntrance(){
      lessonEntranceRAF=0;
      if(!initLayer||!initLayer.hasAttribute('data-toot-init-pending')){ cleanup(); return; }
      var branch=studioBranch();
      if(!branch||!seatUsable(branch)) return;
      cleanup();
      revealStudioBird(branch,!!(matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches));
    }
    function queueLessonEntrance(){
      if(!lessonEntranceRAF) lessonEntranceRAF=requestAnimationFrame(checkLessonEntrance);
    }
    addEventListener('scroll',queueLessonEntrance,{passive:true});
    addEventListener('resize',queueLessonEntrance,{passive:true});
    if(window.IntersectionObserver){
      var branch=studioBranch();
      if(branch){
        lessonEntranceIO=new IntersectionObserver(queueLessonEntrance,{threshold:[0,0.15,0.5]});
        lessonEntranceIO.observe(branch);
      }
    }
    queueLessonEntrance();
  }
  function entrance(){
    if(window.__tootFreeze||micLive) return;
    if(pcBanner()&&_entTries<25){ _entTries++; setTimeout(entrance,900); return; } /* wait out the consent dialog */
    var reduce=matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches;
    var h=null; try{ h=JSON.parse(sessionStorage.getItem('toot.h1')||'null'); sessionStorage.removeItem('toot.h1'); }catch(e){}
    var cont=h&&h.v===1&&(Date.now()-h.ts)<15000;
    if(cont&&h.size>=56&&h.size<=200) setSize(h.size);
    if(tpl==='index'&&jEls.length){
      var q=jEls[0], qs=seatY(q);
      /* start on the quiz only when the user is actually at the top looking at it */
      if(scrollY>80||qs.ay<HEADROOM()-10||qs.ay>innerHeight*0.86){ if(followCheck) followCheck(); return; }
      if(reduce){ glueTo(q); return; }
      pos = cont ? {x:(h.dir==='left'?innerWidth+BW:-BW-20), y:Math.max(60,h.ey*innerHeight)}
                 : {x:innerWidth+BW, y:-BW*0.5};
      state='fly'; apply();
      runScript([{fly:{el:q,ry:+(q.dataset.perchRy||0)},style:cont?'sweep':'swoop',land:true}]);
      return; }
    // On the dedicated Studio, fly in from the side directly to the branch. No
    // toolbar/graph/controls tour and no fallback to a generic data-perch.
    var studioEl = studioSeat();
    if(studioFocusedTemplate){
      if(!studioEl&&_entTries<25){ _entTries++; setTimeout(entrance,220); return; }
      /* A lesson's Studio begins below its article. Keep the whole mascot layer
         hidden until the real branch is on screen, then use the same side-flight
         entrance as the standalone Studio. */
      if(lessonStudioTemplate&&studioEl&&!seatUsable(studioEl)){
        armLessonStudioEntrance();
        return;
      }
      if(studioEl) revealStudioBird(studioEl,reduce);
      return;
    }
    if (studioEl) {
      var sr = studioEl.getBoundingClientRect();
      if (reduce) { takeSeat(studioEl, false); return; }
      studioEl.dataset.perch = '';
      if (!studioEl.dataset.perchRx) studioEl.dataset.perchRx = String(rtl ? 0.82 : 0.18);
      pos = { x: cont ? (h.dir === 'left' ? innerWidth + BW : -BW - 20) : innerWidth - BW * 1.2,
              y: Math.max(-BW * 0.4, Math.min(innerHeight * 0.4, sr.top - BW * 1.6)) };
      state = 'fly'; apply();
      runScript([{ fly: { el: studioEl, ry: +(studioEl.dataset.perchRy || 0) }, style: cont ? 'sweep' : 'swoop', land: true }]);
      return;
    }
    var defs=(MAP[tpl]||[]).concat(GLOBAL);
    if(!defs.length&&!document.querySelector('[data-perch]')) return; /* no perches on this template: stay away */
    var target=null, best=-1;
    perches().forEach(function(el){ var p=+(el.dataset.perchPri||1); if(p>best&&visible(el)){best=p;target=el;} });
    if(!target){ /* nothing cleanly visible up top: land on the best below-fold perch — discovery on scroll */
      perches().forEach(function(el){ var r=el.getBoundingClientRect(), p=+(el.dataset.perchPri||1);
        if(r.top>innerHeight*0.35&&p>best){best=p;target=el;} }); }
    if(!target) target=perches()[0]; if(!target) return;
    /* below-fold target: flying/placing both clamp to the viewport ("lands on nothing") —
       glue him straight onto the perch with rideNow's unclamped math; discovered on scroll */
    var tr=target.getBoundingClientRect();
    if(reduce||tr.top>innerHeight*0.9){
      clearRigTransition(); resetRigPose(); perchedOn=target; freeAnchor=null; state='perch'; toot.classList.add('idle');
      rideNow(); return; }
    var fromX = cont ? (h.dir==='left'?innerWidth+BW:-BW-20) : innerWidth-BW*1.2; /* opposite edge of exit */
    var fromY = cont ? Math.max(40,h.ey*innerHeight) : -BW*0.4;
    pos={x:fromX,y:fromY}; state='fly'; apply();
    var steps=[{fly:{el:target,ry:0},style:cont?'sweep':'swoop',land:true}];
    if(target.dataset.sing!==undefined&&!cont) steps.push({sing:true,ms:900});
    runScript(steps);
  }
  if('requestIdleCallback' in window) requestIdleCallback(function(){ setTimeout(entrance,600); },{timeout:2500});
  else setTimeout(entrance,1400);

  // Cheap and steady: a rect read every 700ms, only acting when he is actually
  // lost. Also catches the teaser closing, which removes his best seat.
  setInterval(seatWatchdog, 700);
  addEventListener('resize', function(){ setTimeout(seatWatchdog, 220); }, { passive: true });
  addEventListener('orientationchange', function(){ setTimeout(seatWatchdog, 420); }, { passive: true });

  /* ================= TEACHING MODE =================
     Toot's job is to teach, and the Practice Studio tour is the lesson. The
     STUDIO owns the steps, the copy and the spotlight; this side only answers
     "where does he stand, and may he chatter". The two are joined by three
     calls and nothing else, so either can be absent without breaking the other:
     the studio null-checks window.SaifToot, and these functions no-op when no
     tour is running.

     He is seated on the TOUR CARD rather than on each spotlit element. The card
     is where the words are, it is always on screen, and it is never inside the
     spotlight ring — so he can never end up behind the dimming shade, on top of
     the thing being pointed at, or clipped off the edge of a small target. He
     hops to whichever end of the card faces what is being described, which is
     the pointing gesture without any of the risk. */
  var teaching=false, teachCard=null, teachRx=null, teachRAF=0;
  var teachSpeech=null, teachSeats=[];
  // One teaching flight at a time. A request arriving mid-flight is remembered
  // (latest wins) and run on landing — two overlapping flyLeg calls null
  // perchedOn and rebuild the path from a moving origin, which is exactly what
  // "he skips everywhere" looked like.
  var teachFlying=false, teachPending=null, teachBW=0, teachBH=0;

  /* The tour scrim is z-index 1000 and dims everything under it. A teacher has
     to be readable, so he teaches from above it — see .saif-toot-teaching. */
  function teachRaise(on){ try{ document.body.classList.toggle('saif-toot-teaching',!!on); }catch(e){} }

  /* The card MOVES between steps (it is placed next to each target, with a CSS
     transition). ride() is event-driven — scroll and resize only — so it cannot
     see that; a short-lived rAF keeps him glued while, and only while, he is
     teaching. */
  var RIDE_EASE='transform 0.18s cubic-bezier(0.33,1,0.68,1)';
  function teachRide(){ teachRAF=teaching?requestAnimationFrame(teachRide):0;
    if(!teaching) return;
    if(state==='perch'&&perchedOn&&perchedOn.isConnected){
      if(rigTransitionOwner!=='tutorial') setRigTransition(RIDE_EASE,'tutorial');
      var r=perchedOn.getBoundingClientRect();
      if(r.width>0&&r.height>0) rideNow();   /* eased track: a big card move glides, it never snaps */
    } else if(rigTransitionOwner==='tutorial') clearRigTransition('tutorial');
  }

  function teachStart(){
    if(teaching) return;
    clearRigTransition();
    teaching=true;
    clearPendingBranchSong(); clearNavMouth(); clearAnger(true);
    try{ if(window.SaifToot&&window.SaifToot.cancelReactions) window.SaifToot.cancelReactions(true); }catch(e){}
    try{ var _c=document.querySelector('.saif-practice-tour__card'); if(_c) _c.classList.remove(
      'saif-practice-tour__card--speech','saif-practice-tour__card--tail-bottom',
      'saif-practice-tour__card--tail-top','saif-practice-tour__card--mute'); }catch(e){}
    hideTip();                    /* no idle tips talking over the lesson */
    window.__tootTeaching=true;   /* followCheck/tipTick both bail on this */
    teachRaise(true);
    if(!teachRAF) teachRAF=requestAnimationFrame(teachRide);
  }

  /* cardEl = the tour card; targetEl = whatever is spotlit right now (may be
     null on a centred step). sing = the beats worth a note: hello and goodbye. */
  /* He sits ON THE HIGHLIGHTED AREA and the card is his speech bubble.
     Centred on a narrow target (a tool tile is barely wider than he is); near
     the left end of a wide one, so the bubble opens into clear space. Steps with
     nothing to point at (hello, score, goodbye) seat him on the studio itself. */
  /* He rides the TOUR CARD, and the studio positions that card next to the
     spotlight for every step. So he is always aligned with what the card is
     about, and never standing on the empty top edge of some big element (which
     is exactly what "what is he standing on" was). He flies in ONCE; after that
     he simply rides the card as it glides to each new spot (teachRide tracks it
     every frame), so the transition IS the card's own smooth move. */
  function teachAt(cardEl,targetEl,opts){
    if(!teaching||micLive||!cardEl||!cardEl.isConnected) return;
    /* lean toward the thing the card points at, so he faces it */
    var rx=0.5;
    try{ if(targetEl&&targetEl.isConnected){
      var c=cardEl.getBoundingClientRect(), t=targetEl.getBoundingClientRect();
      rx=((t.left+t.width/2)<(c.left+c.width/2))?0.3:0.7;
    } }catch(e){}
    if(rtl) rx=1-rx;
    cardEl.dataset.perch=''; cardEl.dataset.perchRx=String(rx); delete cardEl.dataset.perchRy;
    if(teachSeats.indexOf(cardEl)<0) teachSeats.push(cardEl);
    teachCard=cardEl; teachRx=rx;
    /* Already on the card (every step after the fly-in): the card just moved to
       this step's spot — ride it there. rideNow reads the card's CURRENT rect,
       and teachRide calls it every frame, so he glides with the card's CSS
       transition instead of teleporting or flying a separate path. */
    if(state==='perch' && perchedOn===cardEl){ rideNow(); if(opts&&opts.first) teachGreet(); return; }
    /* Not on the card yet — the one fly-in. Serialised so a fast Next during
       the swoop cannot start a second overlapping flight. */
    if(teachFlying){ teachPending=[cardEl,targetEl,opts]; return; }
    teachFlying=true;
    var done=function(){ teachFlying=false;
      if(teachPending){ var q=teachPending; teachPending=null; teachAt(q[0],q[1],q[2]); return; }
      if(!teaching) return; rideNow(); if(opts&&opts.first) teachGreet(); };
    var flight=null;
    try{ flight=flyTo(cardEl,'swoop',{quiet:true,v:560}); }catch(e){ glueTo(cardEl); }
    if(flight&&flight.then) flight.then(done,done); else setTimeout(done,60);
  }

  /* Hello, in bird: a wave and his shortest song. "In bird form" — no words,
     the words are in the bubble. */
  function teachGreet(){
    if(!teaching||micLive) return;
    try{ doWave(true); }catch(e){}
    try{ setEyes('happy'); }catch(e){}
    setTimeout(function(){ if(teaching&&!micLive) teachSong('Pettigrew Hello'); },260);
    setTimeout(function(){ try{ setEyes('open'); }catch(e){} },1800);
  }

  /* Play one named song, ignoring the idle gates — a lesson beat is never
     "ambient", so it must not lose a race with them. */
  function teachSong(name){
    if(micLive) return 0;
    var song=null;
    try{
      var e=engine();
      if(e&&e.songs) for(var i=0;i<e.songs.length;i++) if(e.songs[i].name===name) song=e.songs[i];
    }catch(err){}
    if(!song) return 0;
    var durMs=Math.round(song.dur*1000);
    if(performance.now()<sndUntil) return 0;
    try{ song.play(); }catch(err){ return 0; }
    sndUntil=performance.now()+durMs+120;
    toot.classList.add('sing');
    try{ tnSingFX(Math.min(1400,durMs)); }catch(err){}
    var seq=['med','half','big','med','broad','half','med','closed'], k=0;
    clearInterval(singT);
    singT=setInterval(function(){ if(micLive){clearInterval(singT);return;} setBeak(seq[k%seq.length]); k++; },150);
    setTimeout(function(){ clearInterval(singT); toot.classList.remove('sing');
      try{ setBeak('closed'); }catch(err){} }, durMs+180);
    return durMs;
  }

  /* A small chirp for Next/Back. The owner asked for the ambient chatter to go
     AND for navigation to feel answered — this is the one that answers. */
  function teachTick(){
    // Fired by the studio on Next/Back BEFORE the step changes: the chirp is the
    // answer to the press, and muting here stops the old step's bubble sitting
    // visible while the page scrolls and he rides to the new seat.
    hideSpeech();
    if(micLive) return;
    var dur=0;
    try{ dur=chirp()||0; }catch(e){}
    if(!dur) return;
    clearNavMouth();
    setBeak('med');
    navMouthTimers.push(setTimeout(function(){ if(teaching&&!micLive) setBeak('open'); },75));
    navMouthTimers.push(setTimeout(function(){ if(teaching&&!micLive) setBeak('med'); },165));
    navMouthTimers.push(setTimeout(function(){
      if(teaching&&!micLive) setBeak('closed');
      navMouthTimers=[];
    },Math.min(320,dur+20)));
  }

  /* The card IS the speech now (he sits on it), so there is no separate bubble
     to hang, mute or aim. These stay as no-ops for the few remaining callers. */
  function hideSpeech(){}
  function showSpeech(){}
  function placeSpeechForced(){}

  /* The bubble hangs off his BEAK, using the same anchor maths as his tip
     bubble — including its rule about never covering the thing he is perched
     on, which matters far more here: that thing is the spotlit element the
     sentence is about. Runs from the teaching rAF, because he moves. */
  function placeSpeech(){}   /* the card is the speech; the studio places it */

  function teachEnd(){
    var endingFlight=teachFlying;
    clearRigTransition('tutorial');
    if(!teaching){
      if(endingFlight) cancelActiveFlight();
      window.__tootTeaching=false; teachRaise(false);
      return;
    }
    teaching=false;
    clearNavMouth();
    window.__tootTeaching=false;
    if(teachRAF){ cancelAnimationFrame(teachRAF); teachRAF=0; }
    teachRaise(false);
    /* The card is about to be removed from the DOM. A disconnected perchedOn
       measures 0x0, which would fling him to the top-left corner — so pin him to
       the page point he is standing on BEFORE letting go of it. */
    /* Release every element the lesson borrowed as a seat — leaving data-perch
       on a tool tile would let him land on it later inside a CLOSED sheet. */
    teachSeats.forEach(function(el){ try{ delete el.dataset.perch; delete el.dataset.perchRx; }catch(e){} });
    teachSeats=[];
    if(endingFlight) cancelActiveFlight();
    teachFlying=false; teachPending=null; teachBW=0; teachBH=0;
    seatHoldUntil=performance.now()+2600;   /* tutorial teardown owns his seat for now */
    if(teachSpeech){
      try{ teachSpeech.classList.remove('saif-practice-tour__card--speech',
        'saif-practice-tour__card--flip','saif-practice-tour__card--below'); }catch(e){}
      teachSpeech=null;
    }
    if(teachCard){ try{ delete teachCard.dataset.perch; }catch(e){} }
    perchedOn=null;
    freeAnchor=rigPageAnchor();
    state='perch';
    resetRigPose(); apply();
    teachCard=null; teachRx=null;
    /* Then take his proper home seat after the lesson. In the dedicated Studio
       that is the branch — never the generic studio-card edge. */
    var home=studioFocusedTemplate
      ? document.querySelector('.saif-practice__toot-seat')
      : document.querySelector('.saif-practice');
    if(home&&!micLive){
      home.dataset.perch='';
      if(studioFocusedTemplate){
        /* The tour card is removed immediately after this call. Seat him on the
           branch now so there is no floating pause or second overlapping flight. */
        glueTo(home);
        setTimeout(function(){ try{ if(!teaching&&!micLive) teachSong('Bayati Bloom'); }catch(e){} },340);
        return;
      }
      home.dataset.perchRx=String(rtl?0.95:0.05);
      /* Lesson over: a proper song, then back to his usual seat. */
      setTimeout(function(){ try{ teachSong('Bayati Bloom'); }catch(e){} },340);
      setTimeout(function(){
        try{ if(!teaching&&!micLive){
          var f=flyTo(home);
          if(f&&f.then) f.then(function(){ try{ setEyes('happy'); setBeak('smile');
            setTimeout(function(){ try{ setEyes('open'); setBeak('closed'); }catch(e2){} },1200); }catch(e2){} });
        } }catch(e){}
      },900);
    }
  }

  /* ================= SCORE CELEBRATION =================
     Four score bands, classified from the same one-decimal value shown in the
     UI. Each band has its own named song, face, mouth rhythm and body energy. */
  var _scoreReactionT=0, _scoreFaceT=0, _scoreBurstT=0, _scoreReactionToken=0;
  function scoreTier(score){
    var n=Number(score);
    if(!isFinite(n)) return -1;
    n=Math.round(Math.max(0,Math.min(10,n))*10)/10;
    return n>=9?3:(n>=8?2:(n>=7?1:0));
  }
  function clearScoreReaction(restoreFace){
    _scoreReactionToken++;
    clearTimeout(_scoreReactionT); clearTimeout(_scoreFaceT); clearTimeout(_scoreBurstT);
    _scoreReactionT=0; _scoreFaceT=0; _scoreBurstT=0;
    clearInterval(singT);
    toot.classList.remove('cheer1','cheer2','cheer3','cheer4','sing');
    delete toot.dataset.scoreTier;
    try{ tnClearNotes(); }catch(e){}
    if(restoreFace!==false&&!micLive&&!isAngry()){
      try{ setBeak('closed'); setEyes('open'); }catch(e){}
    }
  }
  function celebrateScore(score){
    if(micLive||scoreTier(score)<0) return false;
    clearScoreReaction(true);
    /* A score can arrive after an automatic stop rather than a fresh click.
       Normally this resumes the context kept alive by the recording interlock. */
    try{ primeAudio(); unlock(); }catch(err){}
    var token=_scoreReactionToken;
    var tier=scoreTier(score);
    var NAMES=['Score Gentle','Score Good','Score Bright','Score Jubilee'];
    var FALLBACK=[700,900,1300,2000];
    var song=null;
    try{
      var e=engine();
      if(e&&e.songs) for(var i=0;i<e.songs.length;i++) if(e.songs[i].name===NAMES[tier]) song=e.songs[i];
    }catch(err){}
    var durMs=song?Math.round(song.dur*1000):FALLBACK[tier];
    if(song&&performance.now()>=sndUntil){
      try{ song.play(); sndUntil=performance.now()+durMs+150; }catch(err){}
    }
    actUntil=Math.max(actUntil,performance.now()+durMs+600);
    hideTip();
    toot.dataset.scoreTier=String(tier);
    toot.classList.add('sing');
    if(!reduceMotion){
      try{ tnSingFX(Math.min([520,850,1500,2200][tier],durMs)); }catch(err){}
      if(tier===3) _scoreBurstT=setTimeout(function(){
        if(token===_scoreReactionToken&&!micLive){ try{ tnSingFX(900); }catch(err){} }
      },820);
    }
    try{ setEyes(['happy','happy','joy','wide'][tier]); }catch(err){}
    var SEQS=[
      ['closed','med','half','med','closed'],
      ['med','half','big','med','half','closed'],
      ['med','half','big','med','broad','half','med','closed'],
      ['big','broad','open','big','broad','half','big','open','broad','med']
    ];
    var seq=SEQS[tier], k=0;
    singT=setInterval(function(){
      if(micLive||token!==_scoreReactionToken){ clearInterval(singT); return; }
      setBeak(seq[k%seq.length]); k++;
    },150);
    var cls='cheer'+(tier+1);
    void toot.offsetWidth;
    toot.classList.add(cls);
    /* Bright and jubilee scores get visible wing excitement while his feet
       remain anchored to the shared result marker. */
    if(tier>=2&&!reduceMotion){ try{ fxFlutterHop(true); }catch(err){} }
    if(tier===3&&!reduceMotion){ try{ emTailFlick(); emCrestFlick(); }catch(err){} }
    _scoreReactionT=setTimeout(function(){
      if(token!==_scoreReactionToken) return;
      clearInterval(singT);
      toot.classList.remove(cls,'sing');
      try{ setBeak(tier<2?'closed':'smile'); }catch(err){}
      _scoreFaceT=setTimeout(function(){
        if(token!==_scoreReactionToken||isAngry()) return;
        try{ setBeak('closed'); setEyes('open'); }catch(err){}
        delete toot.dataset.scoreTier;
      },tier<2?350:900);
    },durMs+220);
    return true;
  }

  /* public API */
  window.SaifToot={ call:function(){callToot();}, hush:setHush, tip:function(t){return showTip(t);},
    teachStart:teachStart, teachAt:teachAt, teachEnd:teachEnd,
    celebrate:celebrateScore, cancelReactions:clearScoreReaction, scoreTier:scoreTier, teachTick:teachTick,
    flutter:function(){ try{ return fxFlutterHop(true); }catch(e){ return false; } },
    teaching:function(){ return teaching; },
    hide:function(){ try{localStorage.setItem('saif:toot:hidden','1');}catch(e){} location.reload(); },
    show:function(){ try{localStorage.removeItem('saif:toot:hidden');}catch(e){} location.reload(); },
    /* preprod art-direction hooks: freeze the brain, place him anywhere, judge by eye */
    freeze:function(on){ window.__tootFreeze=!!on; if(on){ hideTip(); } },
    seat:function(sel,rx,ry,size){ var el=typeof sel==='string'?document.querySelector(sel):sel; if(!el) return 'no match: '+sel;
      clearRigTransition();
      if(size) setSize(size);
      if(rx!=null) el.dataset.perchRx=String(rx);
      if(ry!=null&&ry!==0) el.dataset.perchRy=String(ry); else delete el.dataset.perchRy;
      el.dataset.perch='';
      clearInterval(singT); toot.classList.remove('sing','wave','land'); resetRigPose();
      perchedOn=el; freeAnchor=null; state='perch'; toot.classList.add('idle'); rideNow();
      var r=el.getBoundingClientRect(), p=rigScreenPos(); return {seatX:Math.round(p.x),seatY:Math.round(p.y),elTop:Math.round(r.top)}; },
    /* Fly to a seat the host page picked. Returns false when he is busy with
       something that outranks scenery (a take, the lesson) so the caller can
       simply try again later instead of fighting him. */
    perchOn:function(sel,opts){
      try{
        var el=typeof sel==='string'?document.querySelector(sel):sel;
        if(!el||!el.isConnected) return false;
        if(!studioAllowedSeat(el)) return false;
        if(micLive||teaching||isAngry()||window.__tootFreeze) return false;
        var r0=el.getBoundingClientRect();
        if(!(r0.width>0&&r0.height>0)) return false;      /* hidden seat: leave him be */
        opts=opts||{};
        if(opts.rx!=null) el.dataset.perchRx=String(rtl?(1-opts.rx):opts.rx);
        if(opts.ry!=null) el.dataset.perchRy=String(opts.ry); else delete el.dataset.perchRy;
        el.dataset.perch='';
        if(perchedOn===el&&state==='perch'){ rideNow(); return true; }
        var f=flyTo(el,opts.style||'swoop',{v:opts.v||460,quiet:true});
        if(f&&f.then&&opts.then) f.then(opts.then,function(){});
        return true;
      }catch(e){ return false; }
    } };
  addEventListener('pagehide',function(){
    clearRigTransition();
    clearTimeout(branchIdleTimer); clearPendingBranchSong(); clearNavMouth(); clearAnger(false); clearScoreReaction(false);
  },{once:true});
})();
